// import { useNavigate, useSearchParams } from "react-router-dom";
// import styles from "./Orders.module.css";
// import React, {
//   useCallback,
//   useEffect,
//   useMemo,
//   useRef,
//   useState,
// } from "react";
// import fetchData from "../../APIsControll/apiControll";
// import { useAuth } from "../../components/context/Auth";
// import InputTag from "../../components/updatedComponents/FormComponents/InputTag";
// import Skeleton from "../../components/updatedComponents/Skeleton/Skeleton";
// import SearchDealer from "../../components/updatedComponents/OrderManager/SearchDealer";
// import DealerAddressModal from "../../components/updatedComponents/OrderManager/DealerAddressModal";
// import AdduserModel from "../../components/updatedComponents/models/AdduserModel";
// import ModalWrapper from "../../components/updatedComponents/layoutWrapper/ModalWrapper";
// import {
//   CancelIcon2,
//   DividerIcon,
//   EditManagerIcon,
//   InfoRounded,
//   NewEyeIcon,
//   RemoveIcon,
//   SaveIcon,
//   ShareIcon,
//   TestTopAddDealerIcon,
// } from "../../components/icons/Icon";
// import ItemList from "../../components/updatedComponents/OrderManager/ItemList";
// import NewItemList from "../../components/updatedComponents/OrderManager/NewItemList";
// import ManagerModal from "../../components/updatedComponents/Manager/ManagerModal";
// import { useToast } from "../../components/updatedComponents/Toaster/Toaster";
// import OrderSuccessModal from "../../components/updatedComponents/OrderManager/OrderSuccessModal";
// import ShareLinkModal from "../../components/updatedComponents/OrderManager/ShareLinkModal";
// import AddReceiptModal from "../../components/updatedComponents/OrderManager/AddReceiptModal";
// import { handleFileData } from "../../APIsControll/apiControl2";
// import Button from "../../components/updatedComponents/Dealers/Button";
// import RequestForCancelModal from "../../components/updatedComponents/OrderManager/RequestForCancelModal";
// import Spinner from "../../components/updatedComponents/FormComponents/Spinner";
// import ConfirmOrder from "../../components/updatedComponents/OrderManager/ConfirmOrder";
// import Warning from "../../components/updatedComponents/Receipts/Warning";
// import ShippingTypeModal from "../../components/updatedComponents/OrderManager/ShippingTypeModal";
// import Selection from "../../components/updatedComponents/OrderManager/Selection";
// import ShippingChargesInfoModal from "../../components/updatedComponents/OrderManager/ShippingChargesInfoModal";
// import ShippingChargesModal2 from "../../components/updatedComponents/OrderManager/ShippingChargesModal2";
// import { useDispatch } from "react-redux";
// import { setFilter } from "../../store/slices/order/OrderSlice";
// import SelectDM from "../../components/updatedComponents/OrderManager/SelectDM";
// import { getStatusColor } from "../../Utils/Utils";
// import SelectWarehouse from "../../components/updatedComponents/OrderManager/SelectWarehouse";
// import MoreDropdown from "../dispatchmanager/MoreDropdown";
// import { useReactToPrint } from "react-to-print";
// import NewSummarySlip from "../dispatchmanager/NewSummarySlip";
// import AdvanceAmountModalInfo from "../../components/updatedComponents/OrderManager/AdvanceAmountModalInfo";

// const SaleOrder = ({ onOrderData }) => {
//   const { managerId, mode, designation } = useAuth();

//   const dispatch = useDispatch();

//   const { show } = useToast();
//   const navigate = useNavigate();
//   const [searchParams] = useSearchParams();
//   const orderId = searchParams.get("orderId")
//     ? searchParams.get("orderId")
//     : "";

//   const dealerInpRef = useRef(null);
//   const locationRef = useRef(null);
//   const scroll_wrapper_ref = useRef(null);
//   const itemInpRefs = useRef([]);
//   const qtyInputRefs = useRef([]);
//   const shippingRef = useRef(null);
//   const checkboxRef = useRef(null);
//   const dispatchManagersRef = useRef();
//   const summarySlipRef = useRef(null);
//   const initialItemDetails = useMemo(
//     () => ({
//       amount: 0,
//       collection_name: "",
//       desc: "",
//       descKey: "",
//       dp: 0,
//       itemNo: "",
//       price: 0,
//       product_name: "",
//       qty: 0,
//       thumbnail: "",
//       totalQty: "",
//       unit: "",
//       vm: 0,
//       warehouse: "",
//       weight: 0,
//     }),
//     [],
//   );

//   const initialReceiptData = useMemo(
//     () => ({
//       paymentMethod: "Cash",
//       transactionScreenshot: "",
//       paymentAmount: "",
//       transactionId: "",
//       accountNumber: "",
//       totalAmount: "",
//       receiptId: "",
//       paymentType: "Cash",
//       warehousename: "",
//       warehouseId: "",
//     }),
//     [],
//   );

//   const [generalInfo, setGeneralInfo] = useState({
//     warehouses: [],
//     selectedDMs: [],
//   });
//   const [itemDetails, setItemDetails] = useState([initialItemDetails]);

//   const flag = useMemo(() => {
//     if (!orderId) {
//       return "create";
//     }
//     if (orderId && generalInfo.status === "Payment Pending") {
//       return "edit";
//     }
//     if (orderId && generalInfo.status !== "Payment Pending") {
//       return "view";
//     }
//     return "";
//   }, [orderId, generalInfo.status]);

//   const [loading, setLoading] = useState(false);
//   const [showSave, setShowSave] = useState(false);
//   const [loadingBtn, setLoadingBtn] = useState(false);
//   const [isEditMode, setIsEditMode] = useState(false);

//   const [receipts, setReceiptsInfo] = useState([]);

//   const [accounts, setAccounts] = useState([]);
//   const [warehouses, setWarehouses] = useState([]);
//   const [dispatchManagers, setDispatchManagers] = useState([]);
//   const [methodPartners, setMethodPartners] = useState([]);

//   const [showDealerSearch, setShowDealerSearch] = useState(
//     flag === "create" ? true : false,
//   );
//   const [searchDealer, setSearchDealer] = useState("");
//   const [dealerLoading, setDealerLoading] = useState(false);
//   const [dealerResults, setDealerResults] = useState([]);
//   const [currentIndex, setCurrentIndex] = useState(0);
//   const [updatedAddress, setUpdatedAddress] = useState(null);
//   const [useFallback, setUseFallback] = useState(true);

//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [modalContent, setModalContent] = useState(null);

//   const [focusedItemIndex, setFocusedItemIndex] = useState(0);
//   const [showItemSearch, setShowItemSearch] = useState(false);

//   const [receiptData, setReceiptData] = useState(initialReceiptData);
//   const [paymentLink, setPaymentLink] = useState("");

//   const [skipped, setSkipped] = useState(false);
//   const [isNoCase, setIsNoCase] = useState(false);

//   const [shouldFocus, setShouldFocus] = useState(true);
//   const [showDescriptionInput, setShowDescriptionInput] = useState(false);

//   const [isManagerAssigned, setIsManagerAssigned] = useState(true);
//   const [isShippingBlocked, setIsShippingBlocked] = useState(false);
//   const [isPodBlocked, setIsPodBlocked] = useState(false);
//   const [orderManagers, setOrderManagers] = useState([]);
//   const [shippingType, setShippingType] = useState("Combined");
//   const [dispatchWarehouse, setDispatchWarehouse] = useState();

//   const [shippingAddress, setShippingAddress] = useState({});
//   const [allOrdersData, setAllOrdersData] = useState([{}]);

//   const initialShippingDetails = {
//     methodId: "",
//     shippingCharge: 0,
//     courierName: "Pick Up",
//     methodName: "Self",
//     partnerName: "Self",
//     warehousename: "",
//     warehouseId: "",
//     isDispatchWarehouse: false,
//     delInstruction: "",
//   };

//   const [shippingInfo, setShippingInfo] = useState([initialShippingDetails]);
//   const [instructions, setInstructions] = useState({});
//   const [uniqueWarehouses, setUniqueWarehouses] = useState([]);
//   const [receiptTotalAmount, setReceiptTotalAmount] = useState();

//   const shippingInfoRef = useRef(shippingInfo);

//   useEffect(() => {
//     shippingInfoRef.current = shippingInfo;
//   }, [shippingInfo]);

//   useEffect(() => {
//     dispatchManagersRef.current = dispatchManagers;
//   }, [dispatchManagers]);

//   useEffect(() => {
//     if (shouldFocus) {
//       dealerInpRef.current?.focus();
//     } else {
//       dealerInpRef.current?.blur();
//     }
//   }, [shouldFocus]);

//   useEffect(() => {
//     if (flag === "create") {
//       setGeneralInfo((prevState) =>
//         Object.keys(prevState).reduce((acc, key) => {
//           acc[key] = 0;
//           return acc;
//         }, {}),
//       );
//       setReceiptData(initialReceiptData);
//       setItemDetails([initialItemDetails]);
//       setDispatchManagers([]);
//       setShowDescriptionInput(false);
//       itemInpRefs.current = [];
//       qtyInputRefs.current = [];
//       setFocusedItemIndex(null);
//       setDealerResults([]);
//       setMethodPartners([]);
//       setIsNoCase(false);
//       setShouldFocus(true);
//       setSearchDealer("");
//       setShowItemSearch(false);
//       setIsEditMode(false);
//       setReceiptsInfo([]);
//       setAccounts([]);
//       setWarehouses([]);
//       setPaymentLink("");
//       setIsModalOpen(false);
//       setModalContent(null);
//       setSkipped(false);
//       setShowSave(false);
//       setLoading(false);
//       setLoadingBtn(false);
//       setIsManagerAssigned(true);
//       setIsShippingBlocked(false);
//       setIsPodBlocked(false);
//       setOrderManagers([]);
//       dispatch(setFilter({ selectedOption: "" }));
//       setShippingAddress({});
//       setShippingInfo([]);
//       setReceiptTotalAmount();
//     }
//   }, [dispatch, flag, initialItemDetails, initialReceiptData]);

//   const fetchOrder = useCallback(async () => {
//     setLoading(true);
//     try {
//       const apiData = {
//         managerId: managerId,
//         orderId: orderId,
//         warehousename: "",
//       };
//       const result = await fetchData("order/order", apiData);

//       if (result.status === "success") {
//         setLoading(false);
//         setAllOrdersData(result?.data);
//         if (result?.data?.order) {
//           setGeneralInfo((prevState) => ({
//             ...prevState,
//             dealerId: result?.data?.order?.dealerId,
//             storeName: result?.data?.order?.storeName,
//             dealerName: result?.data?.order?.name,
//             createdBy: result?.data?.order?.createdBy,
//             billingAddress: result?.data?.order?.billingAddress,
//             shippingCharge: result?.data?.order?.totalShippingCharge,
//             totalAmount: result?.data?.order?.totalAmount,
//             subtotal: result?.data?.order?.subtotal,
//             courierName: result?.data?.order?.courierName,
//             mobile: result?.data?.order?.shippingAddress?.mobile
//               ? result?.data?.order?.shippingAddress?.mobile
//               : result?.data?.order?.DealerInfo?.whatsapp,
//             whatsapp: result?.data?.order?.DealerInfo?.whatsapp
//               ? result?.data?.order?.DealerInfo?.whatsapp
//               : result?.data?.order?.shippingAddress?.mobile,
//             email: result?.data?.order?.DealerInfo?.email
//               ? result?.data?.order?.DealerInfo?.email
//               : "",
//             orderManagerName: result?.data?.order?.orderManagerName,
//             dmId: result?.data?.order?.dmId,
//             dmName: result?.data?.order?.dmName,
//             orderDate: result?.data?.order?.orderDate,
//             orderId: result?.data?.order?.orderId,
//             status: result?.data?.order?.status,
//             orderType: result?.data?.order?.orderType,
//             toPay: result?.data?.order?.toPay,
//             dispatchStatus: result?.data?.order?.dispatchStatus,
//             reqType: result?.data?.order?.reqType,
//             deliveryPartners: result?.data?.order?.shippingInfo?.map((d) => ({
//               label: d.methodName,
//               value: d.methodName,
//             })),
//           }));
//           setUniqueWarehouses(
//             result?.data?.order?.shippingInfo?.map((d) => ({
//               label: d.warehousename,
//               value: d.warehouseId,
//             })),
//           );
//           setDispatchManagers(
//             result.data.dispatchmanagers.map((d) => ({
//               label: d.name,
//               value: d.managerId,
//               warehousename: d.warehousename,
//               warehouseId: d.warehouseId,
//             })),
//           );
//           setDispatchWarehouse(() => {
//             if (shippingType !== "Separate") {
//               const dispatchWarehouse = result?.data?.order?.shippingInfo?.find(
//                 (d) => d.isDispatchWarehouse === true,
//               );
//               return dispatchWarehouse
//                 ? {
//                     label: dispatchWarehouse.warehousename || "",
//                     value: dispatchWarehouse.warehouseId || "",
//                   }
//                 : { label: "", value: "" };
//             }

//             return { label: "", value: "" };
//           });
//           setReceiptData((prev) => {
//             const warehouse =
//               shippingType !== "Separate"
//                 ? result?.data?.order?.shippingInfo?.find(
//                     (d) => d.isDispatchWarehouse === true,
//                   ) || ""
//                 : "";

//             return {
//               ...prev,
//               warehousename: warehouse.warehouseId,
//               warehouseId: warehouse.warehouseId,
//             };
//           });
//           setShippingInfo(result.data.order.shippingInfo);
//           setShippingAddress(result?.data?.order?.shippingAddress);
//           setItemDetails(result?.data?.order?.items);
//           setReceiptsInfo(result?.data?.receipts);
//           setIsPodBlocked(
//             result?.data?.order?.DealerInfo?.podBlock ? true : false,
//           );
//           setIsShippingBlocked(
//             result?.data?.order?.DealerInfo?.shippingBlock ? true : false,
//           );
//           setShippingType(result.data.order.shippingType);
//         }
//         if (result.data.accounts) {
//           setAccounts(result.data.accounts);
//         }
//       }
//     } catch {
//     } finally {
//       setLoading(false);
//     }
//   }, [managerId, orderId, shippingType]);

//   const fetchOrderRef = useRef(fetchOrder);
//   fetchOrderRef.current = fetchOrder;

//   useEffect(() => {
//     if (managerId && (flag === "edit" || flag === "view")) {
//       fetchOrder();
//     }
//   }, [fetchOrder, flag, managerId, orderId, shippingType]);

//   const fetchDMs = useCallback(
//     async (warehouse, oID) => {
//       try {
//         const apiData = {
//           managerId: managerId,
//           orderId: orderId || oID,
//           wareHouse: warehouse,
//         };

//         const result = await fetchData("order/order", apiData);

//         if (result.status === "success") {
//           if (result.data.warehouses) {
//             setWarehouses(result.data.warehouses);
//           }

//           if (warehouse === "") {
//             if (result.data.accounts) {
//               setAccounts(result.data.accounts);
//               return result.data.accounts;
//             } else {
//               setAccounts([]);
//               return [];
//             }
//           } else {
//             if (result.data.dispatchmanagers?.length > 0) {
//               setDispatchManagers(
//                 result.data.dispatchmanagers.map((d) => ({
//                   label: d.name,
//                   value: d.managerId,
//                   warehousename: d.warehousename,
//                   warehouseId: d.warehouseId,
//                 })),
//               );
//             }
//           }
//         }
//       } catch (error) {}
//     },
//     [managerId, orderId],
//   );

//   const fetchDealer = useCallback(async () => {
//     try {
//       setDealerLoading(true);
//       const apiData = {
//         managerId: managerId,
//         keyword: searchDealer,
//       };

//       const result = await fetchData("order/finddealer", apiData);

//       if (result.status === "success") {
//         setDealerResults(result.data);
//       }
//       setDealerLoading(false);
//     } catch (error) {
//       setDealerLoading(false);
//     }
//   }, [managerId, searchDealer]);

//   useEffect(() => {
//     if (searchDealer) {
//       const delayDebounceFn = setTimeout(() => {
//         fetchDealer();
//       }, 700);

//       return () => clearTimeout(delayDebounceFn);
//     }
//   }, [searchDealer, fetchDealer]);

//   const handleDealerKeyDown = (e) => {
//     if (showDealerSearch) {
//       if (e.key === "ArrowDown") {
//         setCurrentIndex((prevIndex) =>
//           prevIndex < dealerResults?.length - 1 ? prevIndex + 1 : prevIndex,
//         );
//         e.preventDefault();
//       }

//       if (e.key === "ArrowUp") {
//         setCurrentIndex((prevIndex) =>
//           prevIndex > 0 ? prevIndex - 1 : prevIndex,
//         );
//         e.preventDefault();
//       }

//       if ((e.altKey || e.metaKey) && e.key.toLowerCase() === "c") {
//         setSearchDealer("");
//         setTimeout(() => {
//           openAddDealerModal();
//         }, 100);
//       }

//       if (!dealerLoading) {
//         if (e.key === "Enter") {
//           e.preventDefault();
//           handleSelectDealer(dealerResults && dealerResults[currentIndex]);
//         }
//       }
//     }
//   };

//   const openAddDealerModal = () => {
//     handleOpenModal(
//       <AdduserModel
//         focus={true}
//         close={() => handleCloseModal()}
//         onDealerAdd={(newDealer) => handleSelectDealer(newDealer)}
//       />,
//     );
//   };

//   const editBtnClick = useCallback(
//     (d) => {
//       setIsEditMode(true);
//       handleOpenModal(
//         <DealerAddressModal
//           name={"dealer_address_modal"}
//           shippingAddress={
//             shippingAddress.street ||
//             shippingAddress.city ||
//             shippingAddress.district ||
//             shippingAddress.state ||
//             shippingAddress.pincode
//               ? [
//                   shippingAddress.street,
//                   shippingAddress.city,
//                   shippingAddress.district,
//                   shippingAddress.state,
//                   shippingAddress.pincode,
//                 ]
//                   .filter(Boolean)
//                   .join(" ")
//               : undefined
//           }
//           ref={locationRef}
//           handleCloseModal={() => handleCloseModal()}
//           onAddressUpdate={(data) => {
//             if (!isModalOpen) {
//               setTimeout(() => {
//                 updateShippingAddress(d, data);
//                 itemInpRefs?.current[0]?.focus();
//               }, 0);
//             }
//           }}
//           mode={mode}
//           onKeyPress={() => {
//             if (!isModalOpen) {
//               setTimeout(() => {
//                 itemInpRefs?.current[0]?.focus();
//               }, 0);
//             }
//           }}
//         />,
//       );
//     },
//     [
//       isModalOpen,
//       mode,
//       shippingAddress.city,
//       shippingAddress.district,
//       shippingAddress.pincode,
//       shippingAddress.state,
//       shippingAddress.street,
//     ],
//   );

//   const handleSelectDealer = (d) => {
//     let doesHaveAddress = false;

//     if (!d) {
//       console.error("Dealer data is undefined!");
//       return;
//     }

//     if (
//       d.street === "" ||
//       d.city === "" ||
//       d.district === "" ||
//       d.state === "" ||
//       d.pincode === ""
//     ) {
//       doesHaveAddress = true;
//     }

//     if (d.assignedManagerId === "") {
//       setIsManagerAssigned(false);
//     }

//     if (d.shippingBlock === true) {
//       setIsShippingBlocked(true);
//     }

//     if (d.podBlock === true) {
//       setIsPodBlocked(true);
//     }

//     setSearchDealer(
//       d.name && d.storeName
//         ? `${d.storeName} / ${d.name}`
//         : d.name || d.storeName || "",
//     );

//     if ("refcode" in d) {
//       updateGeneralInfo(d);
//       updateShippingAddress(d);
//     } else {
//       handleOpenModal(
//         <DealerAddressModal
//           name={"dealer_address_modal"}
//           shippingAddress={
//             d.street || d.city || d.district || d.state || d.pincode
//               ? [d.street, d.city, d.district, d.state, d.pincode]
//                   .filter(Boolean)
//                   .join(" ")
//               : undefined
//           }
//           form={doesHaveAddress}
//           ref={locationRef}
//           handleCloseModal={() => handleCloseModal()}
//           onAddressUpdate={(data) => {
//             setUpdatedAddress(data);
//             updateGeneralInfo(d);
//             updateShippingAddress(d, data);
//           }}
//           mode={mode}
//           onKeyPress={(e) => {
//             e.preventDefault();
//             e.stopPropagation();
//             updateGeneralInfo(d);
//             updateShippingAddress(d, updatedAddress);
//           }}
//           focus={true}
//         />,
//       );
//     }
//   };

//   const updateGeneralInfo = (d) => {
//     if (d?.name === "Cash") {
//       setGeneralInfo((prevState) => ({
//         ...prevState,
//         dealerId: d?.dealerId,
//         dealerName: d?.name,
//         storeName: d?.storeName,
//         mobile: d?.mobile,
//         whatsapp: d?.whatsapp,
//         email: d?.email,
//         gstuin: d?.gstuin ? d?.gstuin : "",
//         assignedManagerId: d?.assignedManagerId || d?.refcode,
//         shippingType: "Standard",
//         courierName: "Pick Up",
//         partnerName: "Self",
//       }));
//     } else {
//       setGeneralInfo((prevState) => ({
//         ...prevState,
//         dealerId: d?.dealerId,
//         dealerName: d?.name,
//         storeName: d?.storeName,
//         mobile: d?.mobile,
//         whatsapp: d?.whatsapp,
//         email: d?.email,
//         gstuin: d?.gstuin,
//         assignedManagerId: d?.assignedManagerId || d?.refcode,
//         billingAddress:
//           (d?.street || d?.city || d?.district || d?.state || d?.pincode) &&
//           [d?.street, d?.city, d?.district, d?.state, d?.pincode]
//             .filter(Boolean)
//             .join(" "),
//       }));
//     }
//     itemInpRefs.current[0]?.focus();
//   };

//   const updateShippingAddress = (dealer, address) => {
//     setShippingAddress((prevState) => ({
//       ...prevState,
//       mobile: dealer?.mobile,
//       name: dealer?.name,
//       storeName: dealer?.storeName,
//       pincode: address?.pinCode || dealer?.pincode,
//       street: address?.streetAddress || dealer?.street,
//       city: address?.city || dealer?.city,
//       district: address?.district || dealer?.district,
//       state: address?.state || dealer?.state,
//     }));
//   };

//   const handleFocusNextItem = () => {
//     setShouldFocus(false);
//     setShowDescriptionInput(false);
//     setTimeout(() => {
//       const lastItemIndex = itemDetails?.length - 1;

//       if (itemInpRefs?.current?.length) {
//         const nextItemIndex = lastItemIndex + 1;

//         if (nextItemIndex < itemInpRefs?.current?.length) {
//           const nextItemRef = itemInpRefs?.current[nextItemIndex];
//           nextItemRef?.focus();
//           setFocusedItemIndex(nextItemIndex);
//         }
//       }
//     }, 0);
//     if (flag === "create") {
//       setShowItemSearch(true);
//     }
//   };

//   const handleItemInputFocus = (index) => {
//     setFocusedItemIndex(index);
//   };

//   const handleItemInputBlur = () => {
//     setTimeout(() => {
//       setShowItemSearch(false);
//       setFocusedItemIndex(null);
//     }, 200);
//   };

//   // useEffect(() => {
//   //   console.log("shippingInfo ", shippingInfo);
//   // }, [shippingInfo]);

//   const handleItemChange = async (index, field, value) => {
//     setItemDetails((prevItems) => {
//       const updatedItems = [...prevItems];
//       const previousItem = { ...updatedItems[index] };

//       updatedItems[index] = { ...updatedItems[index], [field]: value };

//       if (field === "warehouseId") {
//         const oldWarehouseId = previousItem.warehouseId;
//         const newWarehouseId = value;
//         const newWarehouseName = updatedItems[index].warehouse;

//         setGeneralInfo((prevState) => {
//           const currentList = prevState.warehouses || [];

//           const isOldWarehouseStillUsed = updatedItems.some(
//             (item, i) => i !== index && item.warehouseId === oldWarehouseId,
//           );

//           let updatedList = [...currentList];

//           if (newWarehouseId && !updatedList.includes(newWarehouseId)) {
//             updatedList.push(newWarehouseId);
//           }

//           if (oldWarehouseId && !isOldWarehouseStillUsed) {
//             updatedList = updatedList.filter((wh) => wh !== oldWarehouseId);
//           }

//           return {
//             ...prevState,
//             warehouses: updatedList,
//           };
//         });

//         setShippingInfo((prevShipping) => {
//           let updatedShipping = [...prevShipping];

//           const isOldWarehouseStillUsed = updatedItems.some(
//             (item, i) => i !== index && item.warehouseId === oldWarehouseId,
//           );

//           if (oldWarehouseId && !isOldWarehouseStillUsed) {
//             updatedShipping = updatedShipping.filter(
//               (item) => item.warehouseId !== oldWarehouseId,
//             );
//           }

//           const newWarehouseExists = updatedShipping.some(
//             (item) => item.warehouseId === newWarehouseId,
//           );

//           if (!newWarehouseExists && newWarehouseId && newWarehouseName) {
//             updatedShipping.push({
//               ...initialShippingDetails,
//               warehouseId: newWarehouseId,
//               warehousename: newWarehouseName,
//             });
//           }

//           return updatedShipping;
//         });
//       }

//       return updatedItems;
//     });
//   };

//   const removeItem = (index) => {
//     setItemDetails((prevItems) => {
//       const itemToRemove = prevItems[index];
//       const updatedItems = prevItems.filter((_, i) => i !== index);

//       if (itemToRemove?.warehouseId) {
//         const isWarehouseStillUsed = updatedItems.some(
//           (item) => item.warehouseId === itemToRemove.warehouseId,
//         );

//         if (!isWarehouseStillUsed) {
//           setShippingInfo((prevShipping) =>
//             prevShipping.filter(
//               (item) => item.warehouseId !== itemToRemove.warehouseId,
//             ),
//           );
//         }
//       }

//       return updatedItems;
//     });
//   };

//   const handleAddNewItem = () => {
//     const errors = [];

//     if (!itemDetails || itemDetails.length === 0) {
//       errors.push("No items to validate");
//     } else {
//       itemDetails.forEach((item, index) => {
//         if (item.outsourcedItem === "Disable") {
//           if (!item.itemNo)
//             errors.push(`Item ${index + 1}: Item Number cannot be empty`);
//           if (!item.qty)
//             errors.push(`Item ${index + 1}: Quantity cannot be empty`);
//           if (item.qty > item.totalQty) {
//             errors.push(
//               `Item ${index + 1}: Quantity exceeds available stock (${
//                 item.totalQty
//               })`,
//             );
//           }
//         } else if (item.outsourcedItem === "Active") {
//           if (!item.itemNo)
//             errors.push(`Item ${index + 1}: Item Number cannot be empty`);
//           if (!item.qty)
//             errors.push(`Item ${index + 1}: Quantity cannot be empty`);
//           if (item.qty > item.outSourceItemlimit) {
//             errors.push(
//               `Item ${index + 1}: Quantity exceeds limit (${
//                 item.outSourceItemlimit
//               })`,
//             );
//           }
//         }
//       });
//     }

//     if (errors.length > 0) {
//       show(errors.join("\n"), "warning");
//     } else {
//       setItemDetails((prev) => [...prev, { ...initialItemDetails }]);
//       handleFocusNextItem();

//       setTimeout(() => {
//         scroll_wrapper_ref.current?.scrollBy({
//           top: 100,
//           behavior: "smooth",
//         });
//       }, 100);
//     }
//   };

//   const handleOpenModal = (content) => {
//     setShouldFocus(false);
//     setIsModalOpen(true);
//     setModalContent(content);
//   };

//   const handleCloseModal = () => {
//     setIsModalOpen(false);
//     setModalContent(null);
//   };

//   const handleAddReceipt = useCallback(
//     async (updatedData, newOrderId, receiptId) => {
//       const formData = new FormData();
//       formData.append(
//         "transactionScreenshot",
//         updatedData.transactionScreenshot
//           ? updatedData.transactionScreenshot
//           : "",
//       );
//       formData.append(
//         "paymentMethod",
//         updatedData.paymentMethod ? updatedData.paymentMethod : "",
//       );
//       formData.append(
//         "paymentType",
//         updatedData.paymentType ? updatedData.paymentType : "",
//       );
//       formData.append(
//         "paymentAmount",
//         updatedData.paymentAmount
//           ? parseFloat(updatedData.paymentAmount).toFixed(2)
//           : "",
//       );
//       formData.append(
//         "transactionId",
//         updatedData.transactionId ? updatedData.transactionId : "",
//       );
//       formData.append(
//         "accountNumber",
//         updatedData.accountNumber ? updatedData.accountNumber : "",
//       );
//       formData.append(
//         "warehousename",
//         updatedData.warehousename ? updatedData.warehousename : "",
//       );
//       formData.append(
//         "totalAmount",
//         generalInfo.totalAmount ? generalInfo.totalAmount.toFixed(2) : "",
//       );

//       const orderIdentifier = newOrderId || orderId;

//       try {
//         const result = await handleFileData(
//           `receipt/offlinePay/${managerId}/${orderIdentifier}?receiptId=${
//             receiptId && receiptId
//           }`,
//           formData,
//         );
//         if (result.status === "success") {
//           show(result.msg, "success");
//           handleCloseModal();
//           setTimeout(async () => {
//             await fetchOrderRef.current();
//           }, 0);
//         }
//         if (result.status === "warning") {
//           setModalContent(
//             <Warning
//               message={result?.msg}
//               items={result?.items}
//               orderdItems={result?.orderdItems}
//               mode={mode}
//               handleCloseModal={handleCloseModal}
//             />,
//           );
//         }
//         if (result.status === "warn") {
//           show(result.msg, "error");
//         }
//         if (result.status === "failed") {
//           show(result.msg, "error");
//         }
//       } catch (error) {}
//     },
//     [generalInfo.totalAmount, managerId, mode, orderId, show],
//   );

//   const updateReceiptData = useCallback(
//     (updatedData, newOrderId, receiptId) => {
//       setReceiptData(updatedData);
//       setTimeout(async () => {
//         handleAddReceipt(updatedData, newOrderId, receiptId);
//       }, 0);
//     },
//     [handleAddReceipt],
//   );

//   const isSelf = shippingInfo?.some((s) => s?.methodName === "Self");

//   const orderSuccessKeyPress = useCallback(
//     (action, link, oID, acc) => {
//       const whatsappNo = generalInfo?.whatsapp || "Not Provided";
//       const mobileNo = generalInfo?.mobile || "Not Provided";
//       const email = generalInfo?.email || "Not Provided";
//       const generatedLink = link || paymentLink || "No Link Available";
//       const newOrderId = orderId || oID || "No Order Id Available";
//       const accounts2 = acc || accounts;

//       if (action === "shareLink") {
//         setTimeout(() => {
//           handleOpenModal(
//             <ShareLinkModal
//               mode={mode}
//               managerId={managerId}
//               handleCloseModal={handleCloseModal}
//               generatedLink={generatedLink}
//               whatsappNo={whatsappNo}
//               mobileNo={mobileNo}
//               email={email}
//               isModalOpen={true}
//             />,
//           );
//         }, 0);
//       } else if (action === "addReceipt") {
//         setTimeout(() => {
//           handleOpenModal(
//             <AddReceiptModal
//               handleCloseModal={handleCloseModal}
//               mode={mode}
//               totalAmount={generalInfo.totalAmount}
//               accounts={accounts2}
//               receiptData={receiptData && receiptData}
//               updateReceiptData={async (updatedData) =>
//                 updateReceiptData(updatedData, newOrderId)
//               }
//               type={"create"}
//               isPodBlocked={isPodBlocked}
//               uniqueWarehouses={uniqueWarehouses}
//               shippingType={shippingType}
//               dispatchWarehouse={dispatchWarehouse}
//               setReceiptData={setReceiptData}
//               isModalOpen={isModalOpen}
//               receiptTotalAmount={receiptTotalAmount}
//               isSelf={isSelf}
//             />,
//           );
//         }, 0);
//       }
//     },
//     [
//       generalInfo?.whatsapp,
//       generalInfo?.mobile,
//       generalInfo?.email,
//       generalInfo.totalAmount,
//       paymentLink,
//       orderId,
//       accounts,
//       mode,
//       managerId,
//       receiptData,
//       isPodBlocked,
//       uniqueWarehouses,
//       shippingType,
//       dispatchWarehouse,
//       isModalOpen,
//       receiptTotalAmount,
//       isSelf,
//       updateReceiptData,
//     ],
//   );

//   const generatePaymentLink = useCallback(
//     async (oId) => {
//       setPaymentLink("");
//       const currentOrderId = oId || orderId;
//       if (!currentOrderId) {
//         return;
//       }
//       try {
//         const apiData = { orderId: currentOrderId };
//         const result = await fetchData("receipt/generatePaymentLink", apiData);
//         if (result.status === "success" && result.shortUrl) {
//           const link = `${result.shortUrl}`;
//           setPaymentLink(link);
//           return link;
//         } else {
//         }
//       } catch (error) {}
//     },
//     [orderId],
//   );

//   const handleSaleOrder = useCallback(
//     async (status, id, s) => {
//       if (
//         generalInfo.partnerName === "" &&
//         generalInfo.methodName === "" &&
//         generalInfo.courierName === ""
//       ) {
//         show("Delivery details are required!", "error");
//         return;
//       }
//       const assignedManagerId = isManagerAssigned
//         ? generalInfo.assignedManagerId
//         : id;

//       try {
//         setLoading(true);

//         const shippingCharge =
//           generalInfo.deliveryPartner === "Self"
//             ? 0
//             : generalInfo.shippingCharge;

//         const apiData = {
//           managerId: managerId,
//           orderId: orderId,
//           gstuin: generalInfo.gstuin,
//           assignedManagerId: assignedManagerId,
//           dealerId: generalInfo.dealerId,
//           shippingType: shippingType,
//           name: shippingAddress.name,
//           street: shippingAddress.street,
//           mobile: shippingAddress.mobile,
//           pincode: shippingAddress.pincode,
//           city: shippingAddress.city,
//           district: shippingAddress.district,
//           state: shippingAddress.state,
//           shippingCharge: shippingCharge,
//           toPay: generalInfo.toPay || false,
//           saleItems: getValidSaleItems(itemDetails),
//           role: designation,
//           status: status,
//           shippingInfo: s,
//         };

//         const result = await fetchData("order/saleOrder", apiData);

//         if (result.status === "success") {
//           setLoading(false);

//           if (status === "success") {
//             if (!orderId) {
//               navigate(
//                 `/orders/order/saleorder?orderId=${result.data.orderId}`,
//               );
//             }
//             setShowSave(false);
//             setIsEditMode(false);
//             dispatch(setFilter({ selectedOption: "" }));
//             setShowItemSearch(false);

//             const oID = result.data.orderId;

//             setTimeout(async () => {
//               const link = await generatePaymentLink(oID);
//               const acc = await fetchDMs("", result.data.orderId);
//               setTimeout(() => {
//                 handleOpenModal(
//                   <OrderSuccessModal
//                     mode={mode}
//                     handleCloseModal={handleCloseModal}
//                     orderSuccessKeyPress={(action) =>
//                       orderSuccessKeyPress(action, link, oID, acc)
//                     }
//                   />,
//                 );
//               }, 100);
//             }, 100);
//           } else if (status === "draft") {
//             navigate("/orders");
//           }
//         } else if (result.status === "assignManager") {
//           setLoading(false);
//           dispatch(setFilter({ selectedOption: "" }));
//           setOrderManagers(result.orderManagers);
//         } else {
//           show(result.msg, "warning");
//           setLoading(false);
//         }
//       } catch (error) {
//         setLoading(false);
//       }
//     },
//     [
//       generalInfo.partnerName,
//       generalInfo.methodName,
//       generalInfo.courierName,
//       generalInfo.assignedManagerId,
//       generalInfo.deliveryPartner,
//       generalInfo.shippingCharge,
//       generalInfo.gstuin,
//       generalInfo.dealerId,
//       generalInfo.toPay,
//       isManagerAssigned,
//       show,
//       managerId,
//       orderId,
//       shippingType,
//       shippingAddress.name,
//       shippingAddress.street,
//       shippingAddress.mobile,
//       shippingAddress.pincode,
//       shippingAddress.city,
//       shippingAddress.district,
//       shippingAddress.state,
//       itemDetails,
//       designation,
//       dispatch,
//       navigate,
//       generatePaymentLink,
//       fetchDMs,
//       mode,
//       orderSuccessKeyPress,
//     ],
//   );

//   const handleInstructionChange = useCallback((warehouseId, instruction) => {
//     setShippingInfo((prev) => {
//       const updated = prev.map((s) =>
//         s.warehouseId === warehouseId
//           ? { ...s, delInstruction: instruction }
//           : s,
//       );
//       return updated;
//     });
//   }, []);

//   const handleSubmit = useCallback(() => {
//     handleOpenModal(
//       <ConfirmOrder
//         heading={"Confirm Order"}
//         centerHeading={"Are you sure want to place this Order?"}
//         targetWord={"order"}
//         handleCloseModal={() => handleCloseModal()}
//         handleSubmit={async (status, id) => {
//           await handleSaleOrder(status, id, shippingInfoRef.current);
//         }}
//         isManagerAssigned={isManagerAssigned}
//         orderManagers={orderManagers}
//         handleOpenModal={handleOpenModal}
//         shippingType={shippingType}
//         itemDetails={itemDetails}
//         setShippingInfo={setShippingInfo}
//         handleInstructionChange={handleInstructionChange}
//         instructions={instructions}
//         setInstructions={setInstructions}
//       />,
//     );
//   }, [
//     handleInstructionChange,
//     handleSaleOrder,
//     instructions,
//     isManagerAssigned,
//     itemDetails,
//     orderManagers,
//     shippingType,
//   ]);

//   const handleSkipShippingCharges = useCallback(
//     (dw) => {
//       if (shippingType === "Combined") {
//         setShippingInfo((prev) =>
//           prev.map((item) => ({
//             ...item,
//             isDispatchWarehouse: item.warehouseId === dw.value,
//           })),
//         );
//       } else {
//         setShippingInfo((prev) =>
//           prev.map((item) => ({
//             ...item,
//             isDispatchWarehouse: true,
//           })),
//         );
//       }
//       setGeneralInfo((prevState) => ({
//         ...prevState,
//         courierName: "Pick Up",
//         toPay: false,
//         deliveryPartners: prevState.deliveryPartners
//           ? [...prevState.deliveryPartners, { label: "Self", value: "Self" }]
//           : [{ label: "Self", value: "Self" }],
//       }));
//       setSkipped(true);
//     },
//     [shippingType],
//   );
//   if (skipped) {
//     setTimeout(() => {
//       handleSubmit();
//     }, 700);
//     setSkipped(false);
//   }

//   const openShippingChargesInfoModal = useCallback(
//     (s, dw, tempShippingInfo, uw) => {
//       setUniqueWarehouses(uw);
//       handleOpenModal(
//         <ShippingChargesInfoModal
//           mode={mode}
//           handleCloseModal={handleCloseModal}
//           shippingType={s}
//           itemDetails={itemDetails}
//           shippingInfo={tempShippingInfo}
//           setShippingInfo={setShippingInfo}
//           dw={dw}
//           ref={checkboxRef}
//         />,
//       );
//     },
//     [itemDetails, mode],
//   );

//   const openSelectDMModal = useCallback(
//     (s, dw, tempShippingInfo, uw) => {
//       handleOpenModal(
//         <SelectDM
//           mode={mode}
//           handleCloseModal={handleCloseModal}
//           uniqueWarehouses={uw}
//           dispatchManagers={dispatchManagersRef.current}
//           setShippingInfo={setShippingInfo}
//           openShippingChargesInfoModal={() =>
//             openShippingChargesInfoModal(s, dw, tempShippingInfo, uw)
//           }
//         />,
//       );
//     },
//     [mode, openShippingChargesInfoModal],
//   );

//   const selectDispatchWarehouse = useCallback(
//     (value) => {
//       setDispatchWarehouse(value);
//       setReceiptData((prev) => ({
//         ...prev,
//         warehousename: value.label,
//         warehouseId: value.value,
//       }));
//       setShippingInfo((prev) => {
//         const updatedShippingInfo = prev.map((item) => ({
//           ...item,
//           isDispatchWarehouse:
//             item.warehouseId === value?.value ||
//             item.warehousename === value.label,
//         }));
//         return updatedShippingInfo;
//       });

//       setTimeout(() => {
//         setShippingInfo((prev) => {
//           fetchDMs(
//             prev.map(({ warehouseId, isDispatchWarehouse }) => ({
//               warehouseId,
//               isDispatchWarehouse,
//             })),
//             "",
//           );
//           return prev;
//         });
//       }, 0);
//     },
//     [fetchDMs],
//   );

//   const openShippingModal2 = useCallback(
//     (shippingType, type2) => {
//       handleOpenModal(
//         <ShippingChargesModal2
//           mode={mode}
//           orderId={orderId}
//           close={() => handleCloseModal()}
//           skipShippingCharges={(dw) => handleSkipShippingCharges(dw)}
//           itemsdetails={getValidSaleItems(itemDetails)}
//           isShippingBlocked={isShippingBlocked}
//           shippingType={shippingType}
//           pincode={shippingAddress.pincode}
//           shippingInfo={shippingInfo}
//           setShippingInfo={setShippingInfo}
//           openSelectDMModal={openSelectDMModal}
//           setGeneralInfo={setGeneralInfo}
//           type2={type2}
//           fetchDMs={(a, b) => fetchDMs(a, b)}
//           setDispatchWarehouse={setDispatchWarehouse}
//           selectDispatchWarehouse={selectDispatchWarehouse}
//         />,
//       );
//     },
//     [
//       mode,
//       orderId,
//       itemDetails,
//       isShippingBlocked,
//       shippingAddress.pincode,
//       shippingInfo,
//       openSelectDMModal,
//       selectDispatchWarehouse,
//       handleSkipShippingCharges,
//       fetchDMs,
//     ],
//   );

//   useEffect(() => {
//     if (isModalOpen && modalContent?.type === ConfirmOrder) {
//       handleSubmit();
//     }
//   }, [handleSubmit, isModalOpen, modalContent?.type]);

//   const getValidSaleItems = (items) => {
//     return items?.filter((item) =>
//       Object.values(item).some(
//         (value) => value !== "" && value !== null && value !== undefined,
//       ),
//     );
//   };

//   useEffect(() => {
//     if (flag === "edit" || flag === "view") {
//       generatePaymentLink(orderId);
//     }
//   }, [flag, generatePaymentLink, orderId]);

//   const handleCancelOrder = async () => {
//     const apiData = {
//       managerId: managerId,
//       orderId: orderId,
//     };
//     try {
//       const result = await fetchData("order/cancelOrder", apiData);
//       if (result.status === "success") {
//         show("Order cancelled successfully", "success");
//         navigate("/orders");
//       }
//     } catch (error) {
//       show(error, "error");
//     }
//   };

//   const handleRequestForCancel = async (reason, warehouseId) => {
//     const apiData = {
//       managerId: managerId,
//       orderId: orderId,
//       reqType: "Request For Cancel",
//       reqIssue: reason,
//       warehouseId: warehouseId,
//     };
//     try {
//       const result = await fetchData("order/orderhelp", apiData);
//       if (result.status === "success") {
//         show(result.msg, "success");
//         navigate("/orders");
//       } else {
//         show(result.msg, "warning");
//       }
//     } catch (error) {
//       show(error, "error");
//     }
//   };

//   const openCancelOrderModal = () => {
//     handleOpenModal(
//       <ManagerModal
//         heading={"Cancel Order"}
//         centerHeading={"Are you sure want to cancel this Order?"}
//         subHeading={"To confirm! type cancel in the text field."}
//         targetWord={"cancel"}
//         handleCloseModal={() => handleCloseModal()}
//         handleSubmit={() => handleCancelOrder()}
//         focus={true}
//       />,
//     );
//   };

//   const openRequestForCancelModal = () => {
//     handleOpenModal(
//       <RequestForCancelModal
//         mode={mode}
//         handleCloseModal={() => handleCloseModal()}
//         handleSubmit={(reason, warehouseId) =>
//           handleRequestForCancel(reason, warehouseId)
//         }
//         type="order"
//         uniqueWarehouses={uniqueWarehouses}
//       />,
//     );
//   };

//   const openShippingTypeModal = () => {
//     handleOpenModal(
//       <ShippingTypeModal
//         mode={mode}
//         handleCloseModal={() => handleCloseModal()}
//         setShippingType={setShippingType}
//         openShippingModal2={(shippingType) => openShippingModal2(shippingType)}
//       />,
//     );
//   };

//   const dispatchDetailsClick = () => {
//     if (shippingInfo.length === 1) {
//       navigate(
//         "/dispatch/details/" + orderId + "/" + shippingInfo[0].warehouseId,
//       );
//     } else {
//       handleOpenModal(
//         <SelectWarehouse
//           mode={mode}
//           handleCloseModal={() => handleCloseModal()}
//           orderId={orderId}
//           shippingInfo={shippingInfo}
//         />,
//       );
//     }
//   };

//   useEffect(() => {
//     itemInpRefs.current = Array(itemDetails.length)
//       .fill()
//       .map((_, i) => itemInpRefs.current[i] || null);
//   }, [itemDetails.length]);

//   useEffect(() => {
//     const handleKeyDown = (event) => {
//       if (event.key === "Tab") {
//         event.preventDefault();
//       }

//       if (loadingBtn) {
//         event.preventDefault();
//         event.stopPropagation();
//       }

//       if (flag === "edit" && !isModalOpen) {
//         const isInputFocused = ["INPUT", "TEXTAREA", "SELECT"].includes(
//           document.activeElement.tagName,
//         );
//         if (
//           !isInputFocused &&
//           generalInfo.orderType !== "online" &&
//           event.key.toLowerCase() === "e"
//         ) {
//           event.preventDefault();
//           editBtnClick();
//         }
//       }
//     };

//     window.addEventListener("keydown", handleKeyDown, true);

//     return () => {
//       window.removeEventListener("keydown", handleKeyDown, true);
//     };
//   }, [editBtnClick, flag, isModalOpen, loadingBtn, generalInfo.orderType]);

//   useEffect(() => {
//     if (!itemDetails || itemDetails.length === 0) return;

//     const amount = itemDetails.reduce((sum, item) => {
//       if (item.amount && !isNaN(item.amount)) {
//         return sum + parseFloat(item.amount);
//       }
//       return sum;
//     }, 0);

//     const cartPriceSum = itemDetails.reduce((sum, currentItem) => {
//       return (
//         sum +
//         parseFloat(currentItem.price ?? 0) * parseFloat(currentItem.qty ?? 0)
//       );
//     }, 0);

//     const cartTotal = itemDetails
//       .map((x) =>
//         !x.accessories
//           ? 0
//           : x.accessories
//               .map((y) => (y.accessoriesQty ?? 0) * (y.accessoriesPrice ?? 0))
//               .reduce((a, b) => a + b, 0),
//       )
//       .reduce((a, b) => a + b, 0);

//     const subtotal = (cartPriceSum ?? 0) + (cartTotal ?? 0);

//     const gettotalAmount =
//       subtotal +
//       parseFloat(
//         generalInfo.toPay
//           ? 0
//           : generalInfo.deliveryPartner === "Self"
//             ? 0
//             : (generalInfo.shippingCharge ?? 0),
//       );

//     const totalAmount = Math.round(gettotalAmount);

//     setGeneralInfo((prev) => ({
//       ...prev,
//       amount,
//       cartPriceSum,
//       cartTotal,
//       subtotal,
//       totalAmount,
//     }));
//   }, [
//     itemDetails,
//     generalInfo.toPay,
//     generalInfo.deliveryPartner,
//     generalInfo.shippingCharge,
//   ]);

//   useEffect(() => {
//     const { totalAmount } = receipts.reduce(
//       (acc, receipt) => {
//         if (receipt.status === "Received") {
//           acc.totalAmount += receipt.paymentAmount;
//         }
//         if (receipt.status === "Cancelled") {
//           acc.cancelledAmount += receipt.paymentAmount;
//         }
//         return acc;
//       },
//       { totalAmount: 0, cancelledAmount: 0 },
//     );

//     setReceiptTotalAmount(totalAmount);
//   }, [receipts]);

//   const allReceived = receipts.every(
//     (receipt) => receipt.status === "Received",
//   );

//   const hasPod = receipts.some((receipt) => receipt.status === "POD Pending");

//   const shouldShowRequestForCancel =
//     orderId &&
//     ["Packing In Progress", "Packed", "Dispatched"].includes(
//       generalInfo.status,
//     ) &&
//     generalInfo.status !== "Cancelled" &&
//     generalInfo.reqType !== "Request For Cancel";

//   const shouldShowCancelOrder =
//     orderId &&
//     ["Payment Pending", "Payment Under Verification"].includes(
//       generalInfo.status,
//     ) &&
//     generalInfo.status !== "Cancelled" &&
//     generalInfo.reqType !== "Request For Cancel";

//   const hasDispatchedOrCompleted = shippingInfo.some(
//     (item) =>
//       item.dispatchStatus === "Completed" ||
//       item.dispatchStatus === "Dispatched",
//   );

//   useEffect(() => {
//     onOrderData({
//       loading,
//       orderId,
//       type: generalInfo.orderType,
//       status: generalInfo.status,
//       orderManagerName: generalInfo.orderManagerName,
//       createdBy: generalInfo.createdBy,
//       orderDate: generalInfo.orderDate,
//     });
//   }, [
//     generalInfo.createdBy,
//     generalInfo.orderDate,
//     generalInfo.orderManagerName,
//     generalInfo.orderType,
//     generalInfo.status,
//     loading,
//     onOrderData,
//     orderId,
//   ]);

//   const verifyEntries = () => {
//     const warnings = [];
//     if (
//       itemDetails.every(
//         (item) =>
//           item.amount === "" &&
//           item.price === "" &&
//           item.unit === "" &&
//           item.qty === "" &&
//           item.itemNo === "",
//       ) ||
//       itemDetails.some((item) =>
//         Object.values(item).every((value) => value === ""),
//       )
//     ) {
//       warnings.push("Item Details are required");
//     }
//     if (warnings?.length === 0) {
//       return true;
//     } else {
//       show(warnings.join(" "), "warning");
//       return false;
//     }
//   };

//   const totalShippingCharges = shippingInfo?.reduce(
//     (sum, item) => sum + (Number(item?.shippingCharge) || 0),
//     0,
//   );

//   useEffect(() => {
//     setGeneralInfo((prev) => ({
//       ...prev,
//       shippingCharge: totalShippingCharges,
//     }));
//   }, [totalShippingCharges]);

//   const headerData = [
//     "S.No",
//     "Item No",
//     "Product",
//     "Warehouse",
//     "Quantity",
//     "Unit",
//     "Rate",
//     "Amount",
//   ];

//   const printSummarySlip = useReactToPrint({
//     content: () => summarySlipRef.current,
//   });

//   const handlePrintSummary = async () => {
//     await fetchOrder(); // fetch latest data
//     // wait for React state update and re-render
//     setTimeout(() => {
//       printSummarySlip();
//     }, 300);
//   };

//   const openAdvancePaymentInfoModal = (data) => {
//     handleOpenModal(<AdvanceAmountModalInfo mode={mode} data={data} />);
//   };

//   return (
//     <>
//       <ModalWrapper isOpen={isModalOpen} onClose={handleCloseModal} noBtn>
//         {modalContent}
//       </ModalWrapper>

//       <div className={styles.so_scroll_wrapper} ref={scroll_wrapper_ref}>
//         <form className={styles.so_form}>
//           <div className={styles.so_form_1}>
//             {loading && (flag === "edit" || flag === "view") ? (
//               <div>
//                 <Skeleton
//                   lines={1}
//                   thickness={4.5}
//                   additionalStyles={{
//                     marginBottom: "0px",
//                     marginTop: "20px",
//                   }}
//                 />
//               </div>
//             ) : (
//               <div style={{ position: "relative" }}>
//                 <InputTag
//                   ref={dealerInpRef}
//                   labelText={"Company or Dealer's Name / ID"}
//                   placeholderText={"Search Dealer"}
//                   padding={"8px"}
//                   fontSize={"12px"}
//                   value={
//                     useFallback && !searchDealer
//                       ? generalInfo.storeName && generalInfo.dealerName
//                         ? `${generalInfo.storeName} / ${generalInfo.dealerName}`
//                         : generalInfo.storeName || generalInfo.dealerName || ""
//                       : searchDealer
//                   }
//                   onChange={(e) => {
//                     setSearchDealer(e.target.value);
//                     setUseFallback(false);
//                   }}
//                   onFocus={() => {
//                     if (flag === "create") {
//                       setShowDealerSearch(true);
//                     }
//                   }}
//                   onBlur={() => {
//                     setShowDealerSearch(false);
//                     if (searchDealer === "") {
//                       setUseFallback(true);
//                     }
//                   }}
//                   onKeyDown={(e) => handleDealerKeyDown(e)}
//                   maxLength={100}
//                   required
//                   enterKeyHint={"enter"}
//                   readOnly={flag === "view"}
//                 />

//                 {showDealerSearch && (
//                   <SearchDealer
//                     mode={mode}
//                     results={dealerResults}
//                     loading={dealerLoading}
//                     currentIndex={currentIndex}
//                     onDealerSelect={handleSelectDealer}
//                     openAddDealerModal={openAddDealerModal}
//                   />
//                 )}
//               </div>
//             )}

//             {loading && (flag === "edit" || flag === "view") ? (
//               <div>
//                 <Skeleton
//                   lines={1}
//                   thickness={4.5}
//                   additionalStyles={{
//                     marginBottom: "0px",
//                     marginTop: "20px",
//                   }}
//                 />
//               </div>
//             ) : (
//               <div>
//                 <InputTag
//                   labelText={"Shipping Address"}
//                   placeholderText={"Enter Dealer Address"}
//                   value={
//                     [
//                       shippingAddress.street,
//                       shippingAddress.city,
//                       shippingAddress.district,
//                       shippingAddress.state,
//                       shippingAddress.pincode,
//                     ]
//                       .filter(Boolean)
//                       .join(" ") || ""
//                   }
//                   padding={"8px"}
//                   fontSize={"12px"}
//                   required
//                 />
//               </div>
//             )}
//           </div>

//           <div className={styles.so_form_1}>
//             <div>
//               {loading && (flag === "edit" || flag === "view") ? (
//                 <div style={{ width: "100%" }}>
//                   <Skeleton
//                     lines={1}
//                     thickness={4.5}
//                     additionalStyles={{
//                       marginBottom: "0px",
//                       marginTop: "20px",
//                     }}
//                   />
//                 </div>
//               ) : (
//                 <div className={styles.warehouse_selectors}>
//                   <div
//                     style={{
//                       width: "100%",
//                       position: "relative",
//                     }}
//                   >
//                     {flag !== "create" && (
//                       <div className={styles.voucher_det}>
//                         <p style={{ color: mode && "#FFFFFF" }}>
//                           {shippingType}
//                         </p>
//                       </div>
//                     )}
//                     <Selection
//                       dropDownText={"Select"}
//                       label={"Warehouses"}
//                       value={
//                         shippingInfo &&
//                         shippingInfo?.map((s) => ({
//                           label: s.warehousename,
//                           value: s.warehouseId,
//                         }))
//                       }
//                       options={
//                         warehouses?.map((w) => ({
//                           label: w.warehousename,
//                           value: w.warehouseId,
//                         })) || []
//                       }
//                       onchange={(option) => {
//                         const selectedValue = option.value;
//                         setGeneralInfo((prevState) => ({
//                           ...prevState,
//                           warehouses: selectedValue,
//                         }));
//                       }}
//                       disableOpen={true}
//                     />
//                   </div>
//                 </div>
//               )}
//             </div>

//             {loading && (flag === "edit" || flag === "view") ? (
//               <div>
//                 <Skeleton
//                   lines={1}
//                   thickness={4.5}
//                   additionalStyles={{
//                     marginBottom: "0px",
//                     marginTop: "20px",
//                   }}
//                 />
//               </div>
//             ) : (
//               <div>
//                 <div style={{ width: "100%", position: "relative" }}>
//                   <div className={styles.voucher_det}>
//                     <p style={{ color: mode && "#FFFFFF" }}>
//                       {[...new Set(shippingInfo?.map((s) => s?.courierName))]
//                         .filter((name) => name)
//                         .join(", ")}
//                     </p>
//                   </div>
//                   <Selection
//                     label="Delivery Method"
//                     dropDownText="Select"
//                     value={generalInfo.deliveryPartners || []}
//                     options={[
//                       { label: "Self", value: "Self" },
//                       ...methodPartners?.map((m) => ({
//                         label: m.methodName || m.partnerName,
//                         value: m.methodName || m.partnerName,
//                       })),
//                     ]}
//                     onchange={(option) => {
//                       const selectedValue = option.value;
//                       setGeneralInfo((prevState) => ({
//                         ...prevState,
//                         deliveryPartners: selectedValue,
//                       }));

//                       if (selectedValue === "Self") {
//                         handleSkipShippingCharges();
//                       } else {
//                         if (isNoCase) {
//                           setGeneralInfo((prev) => ({
//                             ...prev,
//                             shippingCharge: 0,
//                           }));
//                         } else {
//                           // orderSubMethod(selectedValue);
//                         }
//                       }
//                       shippingRef.current?.focus();
//                     }}
//                     disableOpen={true}
//                     collapseDuplicates={true}
//                   />

//                   {isEditMode && (
//                     <div className={styles.change_ship}>
//                       <span
//                         style={{ color: !mode && "#4164E3" }}
//                         onClick={() => openShippingModal2(shippingType, "")}
//                       >
//                         Update
//                       </span>
//                     </div>
//                   )}
//                 </div>
//               </div>
//             )}
//           </div>
//         </form>
//         <ul className={styles.p_table}>
//           <div
//             className={styles.p_table_header_con}
//             style={{
//               visibility: loading && "hidden",
//             }}
//           >
//             <li
//               className={`${styles.p_table_header} ${
//                 mode ? styles.p_table_header_dark : ""
//               }`}
//             >
//               {headerData?.map((h, index) => (
//                 <div className={styles.entry_2} key={`${h}-${index}`}>
//                   {h}
//                 </div>
//               ))}
//             </li>
//             {(flag === "create" || isEditMode) && itemDetails?.length > 1 && (
//               <div
//                 style={{
//                   visibility: "hidden",
//                   display: flag === "view" && "none",
//                 }}
//               >
//                 <RemoveIcon />
//               </div>
//             )}
//           </div>

//           <div className={styles.p_table_list}>
//             <>
//               {itemDetails?.map((item, index) => (
//                 <React.Fragment key={index}>
//                   {flag === "create" || (flag === "edit" && isEditMode) ? (
//                     <NewItemList
//                       mode={mode}
//                       index={index}
//                       item={item}
//                       itemInpRefs={(el) => {
//                         if (el) itemInpRefs.current[index] = el;
//                       }}
//                       quantityRefs={qtyInputRefs}
//                       onItemChange={(field, value) =>
//                         handleItemChange(index, field, value)
//                       }
//                       onRemove={() => removeItem(index)}
//                       onAddNewItem={handleAddNewItem}
//                       itemDetailsLength={itemDetails.length}
//                       itemFocus={handleItemInputFocus}
//                       itemBlur={handleItemInputBlur}
//                       focusedItemIndex={focusedItemIndex}
//                       showItemSearch={showItemSearch}
//                       setShowItemSearch={setShowItemSearch}
//                       onShowDesc={(value) => setShowDescriptionInput(value)}
//                       onCompletion={() => {
//                         if (shippingInfo.length === 1) {
//                           openShippingModal2("Combined", "normal");
//                         } else {
//                           openShippingTypeModal();
//                         }
//                       }}
//                       flag={flag}
//                     />
//                   ) : (
//                     <>
//                       {loading ? (
//                         <div>
//                           <Skeleton
//                             lines={
//                               itemDetails?.length === 1
//                                 ? 1
//                                 : itemDetails?.length / 2
//                             }
//                             thickness={5}
//                             additionalStyles={{
//                               marginBottom: "0px",
//                               marginTop: "0px",
//                             }}
//                           />
//                         </div>
//                       ) : (
//                         <ItemList d={item} index={index} mode={mode} />
//                       )}
//                     </>
//                   )}
//                 </React.Fragment>
//               ))}
//             </>
//           </div>

//           {(flag === "create" || isEditMode) && (
//             <div
//               className={styles.cricle_btn}
//               onClick={() => {
//                 handleAddNewItem();
//               }}
//             >
//               <TestTopAddDealerIcon color="#4164E3" />
//             </div>
//           )}

//           {showDescriptionInput && (flag === "create" || flag === "edit") && (
//             <div className={styles.so_instc}>
//               <p>Press Enter to Add Item</p>
//               <DividerIcon />
//               <p>Double Enter for Next Option</p>
//               <DividerIcon />
//               <p>Ctrl + Backspace for Remove Item</p>
//             </div>
//           )}
//         </ul>
//       </div>

//       {loading ? (
//         <div
//           style={{ padding: "0", boxShadow: "none" }}
//           className={`${styles.so_footer} ${mode ? styles.so_footer_dark : ""}`}
//         >
//           <Skeleton
//             lines={1}
//             thickness={5}
//             additionalStyles={{
//               marginBottom: "0px",
//               marginTop: "0px",
//               borderRadius: "15px 15px 0 0",
//             }}
//           />
//         </div>
//       ) : (
//         <div
//           className={`${styles.so_footer} ${mode ? styles.so_footer_dark : ""}`}
//         >
//           {(flag === "edit" || flag === "view") && (
//             <div className={styles.so_footer_left}>
//               <div
//                 className={`${styles.so_receipt_data} ${
//                   mode ? styles.so_receipt_data_dark : ""
//                 }`}
//               >
//                 <div
//                   className={`${styles.so_receipt_data_header} ${
//                     mode ? styles.so_receipt_data_header_dark : ""
//                   }`}
//                   style={{ cursor: "auto" }}
//                 >
//                   <div className="col">Receipt ID</div>
//                   <div className="col">Method</div>
//                   <div className="col">Amount</div>
//                   <div className="col">Status</div>
//                 </div>
//                 <div
//                   className={styles.scroll_con}
//                   style={{ display: receipts?.length === 0 && "none" }}
//                 >
//                   {receipts?.length !== 0 &&
//                     receipts?.map((r, index) => (
//                       <div
//                         className={`${styles.so_receipt_data_entry} ${
//                           mode ? styles.so_receipt_data_entry_dark : ""
//                         }`}
//                         key={index}
//                         onClick={() => {
//                           handleOpenModal(
//                             <AddReceiptModal
//                               handleCloseModal={handleCloseModal}
//                               mode={mode}
//                               totalAmount={generalInfo.totalAmount}
//                               accounts={accounts}
//                               receiptData={r}
//                               updateReceiptData={async (updatedData) =>
//                                 updateReceiptData(
//                                   updatedData,
//                                   orderId,
//                                   r.receiptId,
//                                 )
//                               }
//                               type={"create"}
//                               flag={"notupdateamount"}
//                               uniqueWarehouses={uniqueWarehouses}
//                               shippingType={shippingType}
//                               dispatchWarehouse={dispatchWarehouse}
//                               setReceiptData={setReceiptData}
//                               isModalOpen={isModalOpen}
//                               receiptTotalAmount={receiptTotalAmount}
//                               isSelf={isSelf}
//                             />,
//                           );
//                         }}
//                       >
//                         <div className="col" key={index + r.receiptId}>
//                           {r.receiptId}
//                         </div>
//                         <div className="col" key={index + r.paymentMethod}>
//                           {r.paymentMethod}
//                         </div>
//                         <div className="col" key={index + r.paymentAmount}>
//                           {r.paymentAmount}
//                         </div>
//                         <div
//                           className="col"
//                           key={index + r.status}
//                           style={{ color: getStatusColor(r.status) }}
//                         >
//                           {r.status}
//                         </div>
//                       </div>
//                     ))}
//                 </div>
//               </div>

//               {(receiptTotalAmount < generalInfo.totalAmount ||
//                 hasPod ||
//                 !allReceived) && (
//                 <div
//                   className={styles.add_receipt_btn}
//                   onClick={async () => {
//                     await fetchDMs();
//                     orderSuccessKeyPress("addReceipt");
//                   }}
//                 >
//                   <TestTopAddDealerIcon />
//                 </div>
//               )}
//             </div>
//           )}

//           <div className={styles.so_footer_right}>
//             <div className={styles.right_btns}>
//               {(flag === "edit" || flag === "view") && (
//                 <MoreDropdown
//                   mode={mode}
//                   // onSummaryClick={() => {
//                   //   printSummarySlip();
//                   //   // show("Coming soon...");
//                   // }}
//                   onSummaryClick={handlePrintSummary}
//                   onSlipClick={() => {
//                     show("Coming soon...");
//                   }}
//                 />
//               )}

//               {shouldShowRequestForCancel && (
//                 <Button
//                   buttonIcon={<CancelIcon2 />}
//                   buttonText={"Request for Cancel"}
//                   buttonBgColor={"#000000"}
//                   buttonTextColor={"#ffffff"}
//                   buttonBorder={"none"}
//                   buttonClick={openRequestForCancelModal}
//                 />
//               )}

//               {shouldShowCancelOrder && (
//                 <Button
//                   buttonIcon={<CancelIcon2 />}
//                   buttonText={"Cancel Order"}
//                   buttonBgColor={"#000000"}
//                   buttonTextColor={"#ffffff"}
//                   buttonBorder={"none"}
//                   buttonClick={openCancelOrderModal}
//                 />
//               )}

//               {(flag === "edit" || flag === "view") && (
//                 <Button
//                   buttonIcon={<NewEyeIcon />}
//                   buttonText={"Invoice"}
//                   buttonBgColor={"#000000"}
//                   buttonTextColor={"#ffffff"}
//                   buttonBorder={"none"}
//                   buttonClick={() =>
//                     navigate("/orders/saleinvoice?orderId=" + orderId)
//                   }
//                 />
//               )}

//               {hasDispatchedOrCompleted && (
//                 <Button
//                   buttonIcon={<NewEyeIcon />}
//                   buttonText={"Dispatch Details"}
//                   buttonBgColor={"#000000"}
//                   buttonTextColor={"#ffffff"}
//                   buttonBorder={"none"}
//                   buttonClick={dispatchDetailsClick}
//                 />
//               )}

//               {(flag === "edit" || flag === "view") &&
//                 generalInfo.status !== "Cancelled" &&
//                 generalInfo.reqType !== "Request For Cancel" && (
//                   <Button
//                     buttonIcon={<ShareIcon />}
//                     buttonText={"Share"}
//                     buttonBgColor={"#4164E3"}
//                     buttonTextColor={"#ffffff"}
//                     buttonBorder={"none"}
//                     buttonClick={() => orderSuccessKeyPress("shareLink")}
//                   />
//                 )}
//             </div>

//             <div
//               className={`${styles.so_amount_info} ${
//                 mode ? styles.so_amount_info_dark : ""
//               }`}
//             >
//               <div>
//                 <p>Sub Total:</p>
//                 <p>₹ {generalInfo.subtotal}</p>
//               </div>

//               <div className={styles.so_shipping}>
//                 <p>Shipping Charges:</p>{" "}
//                 <div className={styles.info_btn_con}>
//                   <span
//                     className={styles.info_btn}
//                     onClick={() =>
//                       openShippingChargesInfoModal(
//                         shippingType,
//                         dispatchWarehouse,
//                         shippingInfo,
//                       )
//                     }
//                   >
//                     <InfoRounded color={mode ? "#FFFFFF" : "#1C274C"} />
//                   </span>
//                 </div>
//                 <input
//                   type="number"
//                   value={
//                     (generalInfo.deliveryPartner === "Self"
//                       ? 0
//                       : generalInfo.shippingCharge
//                     )
//                       ?.toString()
//                       .replace(/^0+/, "") || 0
//                   }
//                   onChange={(e) => {
//                     let value = Number(e.target.value);
//                     if (value > 0) {
//                       setGeneralInfo((prevState) => ({
//                         ...prevState,
//                         shippingCharge: value,
//                       }));
//                     } else {
//                       setGeneralInfo((prevState) => ({
//                         ...prevState,
//                         shippingCharge: -1 * value,
//                       }));
//                     }
//                   }}
//                   readOnly={!isNoCase || flag === "view"}
//                   maxLength="10"
//                   onInput={(e) =>
//                     (e.target.value = e.target.value.slice(0, 10))
//                   }
//                   style={mode ? { color: "#fff" } : {}}
//                   ref={shippingRef}
//                   onKeyDown={(e) => {
//                     if (e.key === "Enter") {
//                       checkboxRef.current?.focus();
//                     }
//                   }}
//                 />
//                 <div className={styles.so_check}>
//                   <p>To Pay</p>
//                   <input
//                     type="checkbox"
//                     checked={generalInfo.toPay}
//                     onChange={(e) => {
//                       const isChecked = e.target.checked;

//                       if (
//                         isChecked &&
//                         isNoCase &&
//                         generalInfo.shippingCharge === 0
//                       ) {
//                         e.preventDefault();
//                         show(
//                           "Update shipping charges to check To Pay!",
//                           "warning",
//                         );
//                         return;
//                       }

//                       setGeneralInfo((prevState) => ({
//                         ...prevState,
//                         toPay: isChecked,
//                       }));
//                     }}
//                     ref={checkboxRef}
//                     disabled={
//                       flag === "view" || (flag === "edit" && !isEditMode)
//                     }
//                     onKeyDown={(e) => {
//                       if (e.key === "Enter") {
//                         handleSubmit();
//                       }
//                     }}
//                   />
//                 </div>
//                 <p>
//                   {loadingBtn ? (
//                     <Spinner
//                       borderWidth={"1px"}
//                       height={10}
//                       width={10}
//                       color={mode ? "#000000" : "#4164E3"}
//                     />
//                   ) : (
//                     <>
//                       ₹{" "}
//                       {generalInfo.deliveryPartner === "Self"
//                         ? 0
//                         : generalInfo.shippingCharge}
//                     </>
//                   )}
//                 </p>
//               </div>

//               {/* <div>
//                 <p>Total Amount(INR):</p>
//                 <p>
//                   {loadingBtn ? (
//                     <Spinner
//                       borderWidth={"1px"}
//                       height={10}
//                       width={10}
//                       color={mode ? "#000000" : "#4164E3"}
//                     />
//                   ) : (
//                     <>₹ {Number(generalInfo.totalAmount) || 0}</>
//                   )}
//                 </p>
//               </div> */}

//               <div>
//                 <p>
//                   Total Amount(INR):{" "}
//                   {receipts?.length > 0 && (
//                     <span
//                       className={styles.info_btn}
//                       onClick={() => openAdvancePaymentInfoModal(receipts)}
//                     >
//                       <InfoRounded color={mode ? "#FFFFFF" : "#1C274C"} />
//                     </span>
//                   )}
//                 </p>

//                 <p>
//                   {loadingBtn ? (
//                     <Spinner
//                       borderWidth={"1px"}
//                       height={10}
//                       width={10}
//                       color={mode ? "#000000" : "#4164E3"}
//                     />
//                   ) : (
//                     <>₹ {Number(generalInfo.totalAmount) || 0}</>
//                   )}
//                 </p>
//               </div>
//             </div>

//             {flag === "edit" && (
//               <div>
//                 {isEditMode ? (
//                   <>
//                     {showSave ? (
//                       <Button
//                         buttonIcon={<SaveIcon />}
//                         buttonText={"Save"}
//                         buttonBgColor={"#4164E3"}
//                         buttonTextColor={"#FFFFFF"}
//                         buttonBorder={"none"}
//                         buttonClick={() => {
//                           if (verifyEntries()) {
//                             handleSubmit();
//                           }
//                         }}
//                       />
//                     ) : (
//                       <div className={styles.flex}>
//                         <Button
//                           buttonIcon={<CancelIcon2 />}
//                           buttonText={"Cancel"}
//                           buttonBgColor={"#000000"}
//                           buttonTextColor={"#ffffff"}
//                           buttonBorder={"none"}
//                           buttonClick={() => setIsEditMode(false)}
//                           loading={loadingBtn}
//                         />
//                       </div>
//                     )}
//                   </>
//                 ) : (
//                   <>
//                     {generalInfo.orderType !== "online" && (
//                       <Button
//                         buttonIcon={<EditManagerIcon />}
//                         buttonText={"Edit"}
//                         buttonBgColor={"#4164E3"}
//                         buttonTextColor={"#FFFFFF"}
//                         buttonBorder={"none"}
//                         buttonClick={editBtnClick}
//                       />
//                     )}
//                   </>
//                 )}
//               </div>
//             )}

//             {flag === "create" && (
//               <div>
//                 {showSave && (
//                   <Button
//                     buttonIcon={<SaveIcon />}
//                     buttonText={"Save"}
//                     buttonBgColor={"#4164E3"}
//                     buttonTextColor={"#FFFFFF"}
//                     buttonBorder={"none"}
//                     buttonClick={() => {
//                       if (verifyEntries()) {
//                         handleSubmit();
//                       }
//                     }}
//                   />
//                 )}
//               </div>
//             )}
//           </div>
//         </div>
//       )}

//       {/* ------------ Summary Slip ------------------- */}

//       <div style={{ display: "none" }}>
//         <NewSummarySlip
//           ref={summarySlipRef}
//           summarySlipData={itemDetails}
//           // generalInfo={generalInfo}
//           generalInfo={allOrdersData?.order}
//         />
//       </div>
//     </>
//   );
// };

// export default SaleOrder;

// ----------------------- for edit item changes --------------------------------

import { useNavigate, useSearchParams } from "react-router-dom";
import styles from "./Orders.module.css";
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import fetchData from "../../APIsControll/apiControll";
import { useAuth } from "../../components/context/Auth";
import InputTag from "../../components/updatedComponents/FormComponents/InputTag";
import Skeleton from "../../components/updatedComponents/Skeleton/Skeleton";
import SearchDealer from "../../components/updatedComponents/OrderManager/SearchDealer";
import DealerAddressModal from "../../components/updatedComponents/OrderManager/DealerAddressModal";
import AdduserModel from "../../components/updatedComponents/models/AdduserModel";
import ModalWrapper from "../../components/updatedComponents/layoutWrapper/ModalWrapper";
import {
  CancelIcon2,
  DividerIcon,
  EditManagerIcon,
  InfoRounded,
  NewEyeIcon,
  RemoveIcon,
  SaveIcon,
  ShareIcon,
  TestTopAddDealerIcon,
} from "../../components/icons/Icon";
import ItemList from "../../components/updatedComponents/OrderManager/ItemList";
import NewItemList from "../../components/updatedComponents/OrderManager/NewItemList";
import ManagerModal from "../../components/updatedComponents/Manager/ManagerModal";
import { useToast } from "../../components/updatedComponents/Toaster/Toaster";
import OrderSuccessModal from "../../components/updatedComponents/OrderManager/OrderSuccessModal";
import ShareLinkModal from "../../components/updatedComponents/OrderManager/ShareLinkModal";
import AddReceiptModal from "../../components/updatedComponents/OrderManager/AddReceiptModal";
import { handleFileData } from "../../APIsControll/apiControl2";
import Button from "../../components/updatedComponents/Dealers/Button";
import RequestForCancelModal from "../../components/updatedComponents/OrderManager/RequestForCancelModal";
import Spinner from "../../components/updatedComponents/FormComponents/Spinner";
import ConfirmOrder from "../../components/updatedComponents/OrderManager/ConfirmOrder";
import Warning from "../../components/updatedComponents/Receipts/Warning";
import ShippingTypeModal from "../../components/updatedComponents/OrderManager/ShippingTypeModal";
import Selection from "../../components/updatedComponents/OrderManager/Selection";
import ShippingChargesInfoModal from "../../components/updatedComponents/OrderManager/ShippingChargesInfoModal";
import ShippingChargesModal2 from "../../components/updatedComponents/OrderManager/ShippingChargesModal2";
import { useDispatch } from "react-redux";
import { setFilter } from "../../store/slices/order/OrderSlice";
import SelectDM from "../../components/updatedComponents/OrderManager/SelectDM";
import { getStatusColor } from "../../Utils/Utils";
import SelectWarehouse from "../../components/updatedComponents/OrderManager/SelectWarehouse";
import MoreDropdown from "../dispatchmanager/MoreDropdown";
import { useReactToPrint } from "react-to-print";
import NewSummarySlip from "../dispatchmanager/NewSummarySlip";
import AdvanceAmountModalInfo from "../../components/updatedComponents/OrderManager/AdvanceAmountModalInfo";

// ─── UID generator (frontend-only, never sent to API) ───────────────────────
let _uidCounter = 0;
const genUid = () => `item-${++_uidCounter}-${Date.now()}`;
// ────────────────────────────────────────────────────────────────────────────

const SaleOrder = ({ onOrderData }) => {
  const { managerId, mode, designation } = useAuth();

  const dispatch = useDispatch();

  const { show } = useToast();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get("orderId")
    ? searchParams.get("orderId")
    : "";

  const dealerInpRef = useRef(null);
  const locationRef = useRef(null);
  const scroll_wrapper_ref = useRef(null);
  const itemInpRefs = useRef([]);
  const qtyInputRefs = useRef([]);
  const shippingRef = useRef(null);
  const checkboxRef = useRef(null);
  const dispatchManagersRef = useRef();
  const summarySlipRef = useRef(null);

  const initialItemDetails = useMemo(
    () => ({
      _uid: genUid(), // frontend-only, stripped before API calls
      amount: 0,
      collection_name: "",
      desc: "",
      descKey: "",
      dp: 0,
      itemNo: "",
      price: 0,
      product_name: "",
      qty: 0,
      thumbnail: "",
      totalQty: "",
      unit: "",
      vm: 0,
      warehouse: "",
      weight: 0,
    }),
    [],
  );

  const initialReceiptData = useMemo(
    () => ({
      paymentMethod: "Cash",
      transactionScreenshot: "",
      paymentAmount: "",
      transactionId: "",
      accountNumber: "",
      totalAmount: "",
      receiptId: "",
      paymentType: "Cash",
      warehousename: "",
      warehouseId: "",
    }),
    [],
  );

  const [generalInfo, setGeneralInfo] = useState({
    warehouses: [],
    selectedDMs: [],
  });
  const [itemDetails, setItemDetails] = useState([initialItemDetails]);

  const flag = useMemo(() => {
    if (!orderId) {
      return "create";
    }
    if (orderId && generalInfo.status === "Payment Pending") {
      return "edit";
    }
    if (orderId && generalInfo.status !== "Payment Pending") {
      return "view";
    }
    return "";
  }, [orderId, generalInfo.status]);

  const [loading, setLoading] = useState(false);
  const [showSave, setShowSave] = useState(false);
  const [loadingBtn, setLoadingBtn] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);

  const [receipts, setReceiptsInfo] = useState([]);

  const [accounts, setAccounts] = useState([]);
  const [warehouses, setWarehouses] = useState([]);
  const [dispatchManagers, setDispatchManagers] = useState([]);
  const [methodPartners, setMethodPartners] = useState([]);

  const [showDealerSearch, setShowDealerSearch] = useState(
    flag === "create" ? true : false,
  );
  const [searchDealer, setSearchDealer] = useState("");
  const [dealerLoading, setDealerLoading] = useState(false);
  const [dealerResults, setDealerResults] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [updatedAddress, setUpdatedAddress] = useState(null);
  const [useFallback, setUseFallback] = useState(true);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState(null);

  const [focusedItemIndex, setFocusedItemIndex] = useState(0);
  const [showItemSearch, setShowItemSearch] = useState(false);

  const [receiptData, setReceiptData] = useState(initialReceiptData);
  const [paymentLink, setPaymentLink] = useState("");

  const [skipped, setSkipped] = useState(false);
  const [isNoCase, setIsNoCase] = useState(false);

  const [shouldFocus, setShouldFocus] = useState(true);
  const [showDescriptionInput, setShowDescriptionInput] = useState(false);

  const [isManagerAssigned, setIsManagerAssigned] = useState(true);
  const [isShippingBlocked, setIsShippingBlocked] = useState(false);
  const [isPodBlocked, setIsPodBlocked] = useState(false);
  const [orderManagers, setOrderManagers] = useState([]);
  const [shippingType, setShippingType] = useState("Combined");
  const [dispatchWarehouse, setDispatchWarehouse] = useState();

  const [shippingAddress, setShippingAddress] = useState({});
  const [allOrdersData, setAllOrdersData] = useState([{}]);

  const initialShippingDetails = {
    methodId: "",
    shippingCharge: 0,
    courierName: "Pick Up",
    methodName: "Self",
    partnerName: "Self",
    warehousename: "",
    warehouseId: "",
    isDispatchWarehouse: false,
    delInstruction: "",
  };

  const [shippingInfo, setShippingInfo] = useState([initialShippingDetails]);
  const [instructions, setInstructions] = useState({});
  const [uniqueWarehouses, setUniqueWarehouses] = useState([]);
  const [receiptTotalAmount, setReceiptTotalAmount] = useState();

  const shippingInfoRef = useRef(shippingInfo);

  useEffect(() => {
    shippingInfoRef.current = shippingInfo;
  }, [shippingInfo]);

  useEffect(() => {
    dispatchManagersRef.current = dispatchManagers;
  }, [dispatchManagers]);

  useEffect(() => {
    if (shouldFocus) {
      dealerInpRef.current?.focus();
    } else {
      dealerInpRef.current?.blur();
    }
  }, [shouldFocus]);

  useEffect(() => {
    if (flag === "create") {
      setGeneralInfo((prevState) =>
        Object.keys(prevState).reduce((acc, key) => {
          acc[key] = 0;
          return acc;
        }, {}),
      );
      setReceiptData(initialReceiptData);
      setItemDetails([{ ...initialItemDetails, _uid: genUid() }]);
      setDispatchManagers([]);
      setShowDescriptionInput(false);
      itemInpRefs.current = [];
      qtyInputRefs.current = [];
      setFocusedItemIndex(null);
      setDealerResults([]);
      setMethodPartners([]);
      setIsNoCase(false);
      setShouldFocus(true);
      setSearchDealer("");
      setShowItemSearch(false);
      setIsEditMode(false);
      setReceiptsInfo([]);
      setAccounts([]);
      setWarehouses([]);
      setPaymentLink("");
      setIsModalOpen(false);
      setModalContent(null);
      setSkipped(false);
      setShowSave(false);
      setLoading(false);
      setLoadingBtn(false);
      setIsManagerAssigned(true);
      setIsShippingBlocked(false);
      setIsPodBlocked(false);
      setOrderManagers([]);
      dispatch(setFilter({ selectedOption: "" }));
      setShippingAddress({});
      setShippingInfo([]);
      setReceiptTotalAmount();
    }
  }, [dispatch, flag, initialItemDetails, initialReceiptData]);

  const fetchOrder = useCallback(async () => {
    setLoading(true);
    try {
      const apiData = {
        managerId: managerId,
        orderId: orderId,
        warehousename: "",
      };
      const result = await fetchData("order/order", apiData);

      if (result.status === "success") {
        setLoading(false);
        setAllOrdersData(result?.data);
        if (result?.data?.order) {
          setGeneralInfo((prevState) => ({
            ...prevState,
            dealerId: result?.data?.order?.dealerId,
            storeName: result?.data?.order?.storeName,
            dealerName: result?.data?.order?.name,
            createdBy: result?.data?.order?.createdBy,
            billingAddress: result?.data?.order?.billingAddress,
            shippingCharge: result?.data?.order?.totalShippingCharge,
            totalAmount: result?.data?.order?.totalAmount,
            subtotal: result?.data?.order?.subtotal,
            courierName: result?.data?.order?.courierName,
            mobile: result?.data?.order?.shippingAddress?.mobile
              ? result?.data?.order?.shippingAddress?.mobile
              : result?.data?.order?.DealerInfo?.whatsapp,
            whatsapp: result?.data?.order?.DealerInfo?.whatsapp
              ? result?.data?.order?.DealerInfo?.whatsapp
              : result?.data?.order?.shippingAddress?.mobile,
            email: result?.data?.order?.DealerInfo?.email
              ? result?.data?.order?.DealerInfo?.email
              : "",
            orderManagerName: result?.data?.order?.orderManagerName,
            dmId: result?.data?.order?.dmId,
            dmName: result?.data?.order?.dmName,
            orderDate: result?.data?.order?.orderDate,
            orderId: result?.data?.order?.orderId,
            status: result?.data?.order?.status,
            orderType: result?.data?.order?.orderType,
            toPay: result?.data?.order?.toPay,
            dispatchStatus: result?.data?.order?.dispatchStatus,
            reqType: result?.data?.order?.reqType,
            deliveryPartners: result?.data?.order?.shippingInfo?.map((d) => ({
              label: d.methodName,
              value: d.methodName,
            })),
          }));
          setUniqueWarehouses(
            result?.data?.order?.shippingInfo?.map((d) => ({
              label: d.warehousename,
              value: d.warehouseId,
            })),
          );
          setDispatchManagers(
            result.data.dispatchmanagers.map((d) => ({
              label: d.name,
              value: d.managerId,
              warehousename: d.warehousename,
              warehouseId: d.warehouseId,
            })),
          );
          setDispatchWarehouse(() => {
            if (shippingType !== "Separate") {
              const dispatchWarehouse = result?.data?.order?.shippingInfo?.find(
                (d) => d.isDispatchWarehouse === true,
              );
              return dispatchWarehouse
                ? {
                    label: dispatchWarehouse.warehousename || "",
                    value: dispatchWarehouse.warehouseId || "",
                  }
                : { label: "", value: "" };
            }

            return { label: "", value: "" };
          });
          setReceiptData((prev) => {
            const warehouse =
              shippingType !== "Separate"
                ? result?.data?.order?.shippingInfo?.find(
                    (d) => d.isDispatchWarehouse === true,
                  ) || ""
                : "";

            return {
              ...prev,
              warehousename: warehouse.warehouseId,
              warehouseId: warehouse.warehouseId,
            };
          });
          setShippingInfo(result.data.order.shippingInfo);
          setShippingAddress(result?.data?.order?.shippingAddress);

          // ── Stamp each item with a frontend-only _uid ──────────────────
          setItemDetails(
            result?.data?.order?.items.map((item) => ({
              ...item,
              _uid: genUid(),
            })),
          );
          // ───────────────────────────────────────────────────────────────

          setReceiptsInfo(result?.data?.receipts);
          setIsPodBlocked(
            result?.data?.order?.DealerInfo?.podBlock ? true : false,
          );
          setIsShippingBlocked(
            result?.data?.order?.DealerInfo?.shippingBlock ? true : false,
          );
          setShippingType(result.data.order.shippingType);
        }
        if (result.data.accounts) {
          setAccounts(result.data.accounts);
        }
      }
    } catch {
    } finally {
      setLoading(false);
    }
  }, [managerId, orderId, shippingType]);

  const fetchOrderRef = useRef(fetchOrder);
  fetchOrderRef.current = fetchOrder;

  useEffect(() => {
    if (managerId && (flag === "edit" || flag === "view")) {
      fetchOrder();
    }
  }, [fetchOrder, flag, managerId, orderId, shippingType]);

  const fetchDMs = useCallback(
    async (warehouse, oID) => {
      try {
        const apiData = {
          managerId: managerId,
          orderId: orderId || oID,
          wareHouse: warehouse,
        };

        const result = await fetchData("order/order", apiData);

        if (result.status === "success") {
          if (result.data.warehouses) {
            setWarehouses(result.data.warehouses);
          }

          if (warehouse === "") {
            if (result.data.accounts) {
              setAccounts(result.data.accounts);
              return result.data.accounts;
            } else {
              setAccounts([]);
              return [];
            }
          } else {
            if (result.data.dispatchmanagers?.length > 0) {
              setDispatchManagers(
                result.data.dispatchmanagers.map((d) => ({
                  label: d.name,
                  value: d.managerId,
                  warehousename: d.warehousename,
                  warehouseId: d.warehouseId,
                })),
              );
            }
          }
        }
      } catch (error) {}
    },
    [managerId, orderId],
  );

  const fetchDealer = useCallback(async () => {
    try {
      setDealerLoading(true);
      const apiData = {
        managerId: managerId,
        keyword: searchDealer,
      };

      const result = await fetchData("order/finddealer", apiData);

      if (result.status === "success") {
        setDealerResults(result.data);
      }
      setDealerLoading(false);
    } catch (error) {
      setDealerLoading(false);
    }
  }, [managerId, searchDealer]);

  useEffect(() => {
    if (searchDealer) {
      const delayDebounceFn = setTimeout(() => {
        fetchDealer();
      }, 700);

      return () => clearTimeout(delayDebounceFn);
    }
  }, [searchDealer, fetchDealer]);

  const handleDealerKeyDown = (e) => {
    if (showDealerSearch) {
      if (e.key === "ArrowDown") {
        setCurrentIndex((prevIndex) =>
          prevIndex < dealerResults?.length - 1 ? prevIndex + 1 : prevIndex,
        );
        e.preventDefault();
      }

      if (e.key === "ArrowUp") {
        setCurrentIndex((prevIndex) =>
          prevIndex > 0 ? prevIndex - 1 : prevIndex,
        );
        e.preventDefault();
      }

      if ((e.altKey || e.metaKey) && e.key.toLowerCase() === "c") {
        setSearchDealer("");
        setTimeout(() => {
          openAddDealerModal();
        }, 100);
      }

      if (!dealerLoading) {
        if (e.key === "Enter") {
          e.preventDefault();
          handleSelectDealer(dealerResults && dealerResults[currentIndex]);
        }
      }
    }
  };

  const openAddDealerModal = () => {
    handleOpenModal(
      <AdduserModel
        focus={true}
        close={() => handleCloseModal()}
        onDealerAdd={(newDealer) => handleSelectDealer(newDealer)}
      />,
    );
  };

  const editBtnClick = useCallback(
    (d) => {
      setIsEditMode(true);
      handleOpenModal(
        <DealerAddressModal
          name={"dealer_address_modal"}
          shippingAddress={
            shippingAddress.street ||
            shippingAddress.city ||
            shippingAddress.district ||
            shippingAddress.state ||
            shippingAddress.pincode
              ? [
                  shippingAddress.street,
                  shippingAddress.city,
                  shippingAddress.district,
                  shippingAddress.state,
                  shippingAddress.pincode,
                ]
                  .filter(Boolean)
                  .join(" ")
              : undefined
          }
          ref={locationRef}
          handleCloseModal={() => handleCloseModal()}
          onAddressUpdate={(data) => {
            if (!isModalOpen) {
              setTimeout(() => {
                updateShippingAddress(d, data);
                itemInpRefs?.current[0]?.focus();
              }, 0);
            }
          }}
          mode={mode}
          onKeyPress={() => {
            if (!isModalOpen) {
              setTimeout(() => {
                itemInpRefs?.current[0]?.focus();
              }, 0);
            }
          }}
        />,
      );
    },
    [
      isModalOpen,
      mode,
      shippingAddress.city,
      shippingAddress.district,
      shippingAddress.pincode,
      shippingAddress.state,
      shippingAddress.street,
    ],
  );

  const handleSelectDealer = (d) => {
    let doesHaveAddress = false;

    if (!d) {
      console.error("Dealer data is undefined!");
      return;
    }

    if (
      d.street === "" ||
      d.city === "" ||
      d.district === "" ||
      d.state === "" ||
      d.pincode === ""
    ) {
      doesHaveAddress = true;
    }

    if (d.assignedManagerId === "") {
      setIsManagerAssigned(false);
    }

    if (d.shippingBlock === true) {
      setIsShippingBlocked(true);
    }

    if (d.podBlock === true) {
      setIsPodBlocked(true);
    }

    setSearchDealer(
      d.name && d.storeName
        ? `${d.storeName} / ${d.name}`
        : d.name || d.storeName || "",
    );

    if ("refcode" in d) {
      updateGeneralInfo(d);
      updateShippingAddress(d);
    } else {
      handleOpenModal(
        <DealerAddressModal
          name={"dealer_address_modal"}
          shippingAddress={
            d.street || d.city || d.district || d.state || d.pincode
              ? [d.street, d.city, d.district, d.state, d.pincode]
                  .filter(Boolean)
                  .join(" ")
              : undefined
          }
          form={doesHaveAddress}
          ref={locationRef}
          handleCloseModal={() => handleCloseModal()}
          onAddressUpdate={(data) => {
            setUpdatedAddress(data);
            updateGeneralInfo(d);
            updateShippingAddress(d, data);
          }}
          mode={mode}
          onKeyPress={(e) => {
            e.preventDefault();
            e.stopPropagation();
            updateGeneralInfo(d);
            updateShippingAddress(d, updatedAddress);
          }}
          focus={true}
        />,
      );
    }
  };

  const updateGeneralInfo = (d) => {
    if (d?.name === "Cash") {
      setGeneralInfo((prevState) => ({
        ...prevState,
        dealerId: d?.dealerId,
        dealerName: d?.name,
        storeName: d?.storeName,
        mobile: d?.mobile,
        whatsapp: d?.whatsapp,
        email: d?.email,
        gstuin: d?.gstuin ? d?.gstuin : "",
        assignedManagerId: d?.assignedManagerId || d?.refcode,
        shippingType: "Standard",
        courierName: "Pick Up",
        partnerName: "Self",
      }));
    } else {
      setGeneralInfo((prevState) => ({
        ...prevState,
        dealerId: d?.dealerId,
        dealerName: d?.name,
        storeName: d?.storeName,
        mobile: d?.mobile,
        whatsapp: d?.whatsapp,
        email: d?.email,
        gstuin: d?.gstuin,
        assignedManagerId: d?.assignedManagerId || d?.refcode,
        billingAddress:
          (d?.street || d?.city || d?.district || d?.state || d?.pincode) &&
          [d?.street, d?.city, d?.district, d?.state, d?.pincode]
            .filter(Boolean)
            .join(" "),
      }));
    }
    itemInpRefs.current[0]?.focus();
  };

  const updateShippingAddress = (dealer, address) => {
    setShippingAddress((prevState) => ({
      ...prevState,
      mobile: dealer?.mobile,
      name: dealer?.name,
      storeName: dealer?.storeName,
      pincode: address?.pinCode || dealer?.pincode,
      street: address?.streetAddress || dealer?.street,
      city: address?.city || dealer?.city,
      district: address?.district || dealer?.district,
      state: address?.state || dealer?.state,
    }));
  };

  const handleFocusNextItem = () => {
    setShouldFocus(false);
    setShowDescriptionInput(false);
    setTimeout(() => {
      const lastItemIndex = itemDetails?.length - 1;

      if (itemInpRefs?.current?.length) {
        const nextItemIndex = lastItemIndex + 1;

        if (nextItemIndex < itemInpRefs?.current?.length) {
          const nextItemRef = itemInpRefs?.current[nextItemIndex];
          nextItemRef?.focus();
          setFocusedItemIndex(nextItemIndex);
        }
      }
    }, 0);
    if (flag === "create") {
      setShowItemSearch(true);
    }
  };

  const handleItemInputFocus = (index) => {
    setFocusedItemIndex(index);
  };

  const handleItemInputBlur = () => {
    setTimeout(() => {
      setShowItemSearch(false);
      setFocusedItemIndex(null);
    }, 200);
  };

  const handleItemChange = async (index, field, value) => {
    setItemDetails((prevItems) => {
      const updatedItems = [...prevItems];
      const previousItem = { ...updatedItems[index] };

      updatedItems[index] = { ...updatedItems[index], [field]: value };

      if (field === "warehouseId") {
        const oldWarehouseId = previousItem.warehouseId;
        const newWarehouseId = value;
        const newWarehouseName = updatedItems[index].warehouse;

        setGeneralInfo((prevState) => {
          const currentList = prevState.warehouses || [];

          const isOldWarehouseStillUsed = updatedItems.some(
            (item, i) => i !== index && item.warehouseId === oldWarehouseId,
          );

          let updatedList = [...currentList];

          if (newWarehouseId && !updatedList.includes(newWarehouseId)) {
            updatedList.push(newWarehouseId);
          }

          if (oldWarehouseId && !isOldWarehouseStillUsed) {
            updatedList = updatedList.filter((wh) => wh !== oldWarehouseId);
          }

          return {
            ...prevState,
            warehouses: updatedList,
          };
        });

        setShippingInfo((prevShipping) => {
          let updatedShipping = [...prevShipping];

          const isOldWarehouseStillUsed = updatedItems.some(
            (item, i) => i !== index && item.warehouseId === oldWarehouseId,
          );

          if (oldWarehouseId && !isOldWarehouseStillUsed) {
            updatedShipping = updatedShipping.filter(
              (item) => item.warehouseId !== oldWarehouseId,
            );
          }

          const newWarehouseExists = updatedShipping.some(
            (item) => item.warehouseId === newWarehouseId,
          );

          if (!newWarehouseExists && newWarehouseId && newWarehouseName) {
            updatedShipping.push({
              ...initialShippingDetails,
              warehouseId: newWarehouseId,
              warehousename: newWarehouseName,
            });
          }

          return updatedShipping;
        });
      }

      return updatedItems;
    });
  };

  const removeItem = (index) => {
    setItemDetails((prevItems) => {
      const itemToRemove = prevItems[index];
      const updatedItems = prevItems.filter((_, i) => i !== index);

      if (itemToRemove?.warehouseId) {
        const isWarehouseStillUsed = updatedItems.some(
          (item) => item.warehouseId === itemToRemove.warehouseId,
        );

        if (!isWarehouseStillUsed) {
          setShippingInfo((prevShipping) =>
            prevShipping.filter(
              (item) => item.warehouseId !== itemToRemove.warehouseId,
            ),
          );
        }
      }

      return updatedItems;
    });
  };

  const handleAddNewItem = () => {
    const errors = [];

    if (!itemDetails || itemDetails.length === 0) {
      errors.push("No items to validate");
    } else {
      itemDetails.forEach((item, index) => {
        if (item.outsourcedItem === "Disable") {
          if (!item.itemNo)
            errors.push(`Item ${index + 1}: Item Number cannot be empty`);
          if (!item.qty)
            errors.push(`Item ${index + 1}: Quantity cannot be empty`);
          if (item.qty > item.totalQty) {
            errors.push(
              `Item ${index + 1}: Quantity exceeds available stock (${
                item.totalQty
              })`,
            );
          }
        } else if (item.outsourcedItem === "Active") {
          if (!item.itemNo)
            errors.push(`Item ${index + 1}: Item Number cannot be empty`);
          if (!item.qty)
            errors.push(`Item ${index + 1}: Quantity cannot be empty`);
          if (item.qty > item.outSourceItemlimit) {
            errors.push(
              `Item ${index + 1}: Quantity exceeds limit (${
                item.outSourceItemlimit
              })`,
            );
          }
        }
      });
    }

    if (errors.length > 0) {
      show(errors.join("\n"), "warning");
    } else {
      // ── New item gets a fresh UID ──────────────────────────────────────
      setItemDetails((prev) => [
        ...prev,
        { ...initialItemDetails, _uid: genUid() },
      ]);
      // ──────────────────────────────────────────────────────────────────
      handleFocusNextItem();

      setTimeout(() => {
        scroll_wrapper_ref.current?.scrollBy({
          top: 100,
          behavior: "smooth",
        });
      }, 100);
    }
  };

  const handleOpenModal = (content) => {
    setShouldFocus(false);
    setIsModalOpen(true);
    setModalContent(content);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setModalContent(null);
  };

  const handleAddReceipt = useCallback(
    async (updatedData, newOrderId, receiptId) => {
      const formData = new FormData();
      formData.append(
        "transactionScreenshot",
        updatedData.transactionScreenshot
          ? updatedData.transactionScreenshot
          : "",
      );
      formData.append(
        "paymentMethod",
        updatedData.paymentMethod ? updatedData.paymentMethod : "",
      );
      formData.append(
        "paymentType",
        updatedData.paymentType ? updatedData.paymentType : "",
      );
      formData.append(
        "paymentAmount",
        updatedData.paymentAmount
          ? parseFloat(updatedData.paymentAmount).toFixed(2)
          : "",
      );
      formData.append(
        "transactionId",
        updatedData.transactionId ? updatedData.transactionId : "",
      );
      formData.append(
        "accountNumber",
        updatedData.accountNumber ? updatedData.accountNumber : "",
      );
      formData.append(
        "warehousename",
        updatedData.warehousename ? updatedData.warehousename : "",
      );
      formData.append(
        "totalAmount",
        generalInfo.totalAmount ? generalInfo.totalAmount.toFixed(2) : "",
      );

      const orderIdentifier = newOrderId || orderId;

      try {
        const result = await handleFileData(
          `receipt/offlinePay/${managerId}/${orderIdentifier}?receiptId=${
            receiptId && receiptId
          }`,
          formData,
        );
        if (result.status === "success") {
          show(result.msg, "success");
          handleCloseModal();
          setTimeout(async () => {
            await fetchOrderRef.current();
          }, 0);
        }
        if (result.status === "warning") {
          setModalContent(
            <Warning
              message={result?.msg}
              items={result?.items}
              orderdItems={result?.orderdItems}
              mode={mode}
              handleCloseModal={handleCloseModal}
            />,
          );
        }
        if (result.status === "warn") {
          show(result.msg, "error");
        }
        if (result.status === "failed") {
          show(result.msg, "error");
        }
      } catch (error) {}
    },
    [generalInfo.totalAmount, managerId, mode, orderId, show],
  );

  const updateReceiptData = useCallback(
    (updatedData, newOrderId, receiptId) => {
      setReceiptData(updatedData);
      setTimeout(async () => {
        handleAddReceipt(updatedData, newOrderId, receiptId);
      }, 0);
    },
    [handleAddReceipt],
  );

  const isSelf = shippingInfo?.some((s) => s?.methodName === "Self");

  const orderSuccessKeyPress = useCallback(
    (action, link, oID, acc) => {
      const whatsappNo = generalInfo?.whatsapp || "Not Provided";
      const mobileNo = generalInfo?.mobile || "Not Provided";
      const email = generalInfo?.email || "Not Provided";
      const generatedLink = link || paymentLink || "No Link Available";
      const newOrderId = orderId || oID || "No Order Id Available";
      const accounts2 = acc || accounts;

      if (action === "shareLink") {
        setTimeout(() => {
          handleOpenModal(
            <ShareLinkModal
              mode={mode}
              managerId={managerId}
              handleCloseModal={handleCloseModal}
              generatedLink={generatedLink}
              whatsappNo={whatsappNo}
              mobileNo={mobileNo}
              email={email}
              isModalOpen={true}
            />,
          );
        }, 0);
      } else if (action === "addReceipt") {
        setTimeout(() => {
          handleOpenModal(
            <AddReceiptModal
              handleCloseModal={handleCloseModal}
              mode={mode}
              totalAmount={generalInfo.totalAmount}
              accounts={accounts2}
              receiptData={receiptData && receiptData}
              updateReceiptData={async (updatedData) =>
                updateReceiptData(updatedData, newOrderId)
              }
              type={"create"}
              isPodBlocked={isPodBlocked}
              uniqueWarehouses={uniqueWarehouses}
              shippingType={shippingType}
              dispatchWarehouse={dispatchWarehouse}
              setReceiptData={setReceiptData}
              isModalOpen={isModalOpen}
              receiptTotalAmount={receiptTotalAmount}
              isSelf={isSelf}
            />,
          );
        }, 0);
      }
    },
    [
      generalInfo?.whatsapp,
      generalInfo?.mobile,
      generalInfo?.email,
      generalInfo.totalAmount,
      paymentLink,
      orderId,
      accounts,
      mode,
      managerId,
      receiptData,
      isPodBlocked,
      uniqueWarehouses,
      shippingType,
      dispatchWarehouse,
      isModalOpen,
      receiptTotalAmount,
      isSelf,
      updateReceiptData,
    ],
  );

  const generatePaymentLink = useCallback(
    async (oId) => {
      setPaymentLink("");
      const currentOrderId = oId || orderId;
      if (!currentOrderId) {
        return;
      }
      try {
        const apiData = { orderId: currentOrderId };
        const result = await fetchData("receipt/generatePaymentLink", apiData);
        if (result.status === "success" && result.shortUrl) {
          const link = `${result.shortUrl}`;
          setPaymentLink(link);
          return link;
        } else {
        }
      } catch (error) {}
    },
    [orderId],
  );

  // ── Strip _uid before sending to API ──────────────────────────────────────
  const getValidSaleItems = (items) => {
    return items
      ?.filter((item) =>
        Object.values(item).some(
          (value) => value !== "" && value !== null && value !== undefined,
        ),
      )
      .map(({ _uid, ...rest }) => rest); // _uid never reaches the API
  };
  // ──────────────────────────────────────────────────────────────────────────

  const handleSaleOrder = useCallback(
    async (status, id, s) => {
      if (
        generalInfo.partnerName === "" &&
        generalInfo.methodName === "" &&
        generalInfo.courierName === ""
      ) {
        show("Delivery details are required!", "error");
        return;
      }
      const assignedManagerId = isManagerAssigned
        ? generalInfo.assignedManagerId
        : id;

      try {
        setLoading(true);

        const shippingCharge =
          generalInfo.deliveryPartner === "Self"
            ? 0
            : generalInfo.shippingCharge;

        const apiData = {
          managerId: managerId,
          orderId: orderId,
          gstuin: generalInfo.gstuin,
          assignedManagerId: assignedManagerId,
          dealerId: generalInfo.dealerId,
          shippingType: shippingType,
          name: shippingAddress.name,
          street: shippingAddress.street,
          mobile: shippingAddress.mobile,
          pincode: shippingAddress.pincode,
          city: shippingAddress.city,
          district: shippingAddress.district,
          state: shippingAddress.state,
          shippingCharge: shippingCharge,
          toPay: generalInfo.toPay || false,
          saleItems: getValidSaleItems(itemDetails),
          role: designation,
          status: status,
          shippingInfo: s,
        };

        const result = await fetchData("order/saleOrder", apiData);

        if (result.status === "success") {
          setLoading(false);

          if (status === "success") {
            if (!orderId) {
              navigate(
                `/orders/order/saleorder?orderId=${result.data.orderId}`,
              );
            }
            setShowSave(false);
            setIsEditMode(false);
            dispatch(setFilter({ selectedOption: "" }));
            setShowItemSearch(false);

            const oID = result.data.orderId;

            setTimeout(async () => {
              const link = await generatePaymentLink(oID);
              const acc = await fetchDMs("", result.data.orderId);
              setTimeout(() => {
                handleOpenModal(
                  <OrderSuccessModal
                    mode={mode}
                    handleCloseModal={handleCloseModal}
                    orderSuccessKeyPress={(action) =>
                      orderSuccessKeyPress(action, link, oID, acc)
                    }
                  />,
                );
              }, 100);
            }, 100);
          } else if (status === "draft") {
            navigate("/orders");
          }
        } else if (result.status === "assignManager") {
          setLoading(false);
          dispatch(setFilter({ selectedOption: "" }));
          setOrderManagers(result.orderManagers);
        } else {
          show(result.msg, "warning");
          setLoading(false);
        }
      } catch (error) {
        setLoading(false);
      }
    },
    [
      generalInfo.partnerName,
      generalInfo.methodName,
      generalInfo.courierName,
      generalInfo.assignedManagerId,
      generalInfo.deliveryPartner,
      generalInfo.shippingCharge,
      generalInfo.gstuin,
      generalInfo.dealerId,
      generalInfo.toPay,
      isManagerAssigned,
      show,
      managerId,
      orderId,
      shippingType,
      shippingAddress.name,
      shippingAddress.street,
      shippingAddress.mobile,
      shippingAddress.pincode,
      shippingAddress.city,
      shippingAddress.district,
      shippingAddress.state,
      itemDetails,
      designation,
      dispatch,
      navigate,
      generatePaymentLink,
      fetchDMs,
      mode,
      orderSuccessKeyPress,
    ],
  );

  const handleInstructionChange = useCallback((warehouseId, instruction) => {
    setShippingInfo((prev) => {
      const updated = prev.map((s) =>
        s.warehouseId === warehouseId
          ? { ...s, delInstruction: instruction }
          : s,
      );
      return updated;
    });
  }, []);

  const handleSubmit = useCallback(() => {
    handleOpenModal(
      <ConfirmOrder
        heading={"Confirm Order"}
        centerHeading={"Are you sure want to place this Order?"}
        targetWord={"order"}
        handleCloseModal={() => handleCloseModal()}
        handleSubmit={async (status, id) => {
          await handleSaleOrder(status, id, shippingInfoRef.current);
        }}
        isManagerAssigned={isManagerAssigned}
        orderManagers={orderManagers}
        handleOpenModal={handleOpenModal}
        shippingType={shippingType}
        itemDetails={itemDetails}
        setShippingInfo={setShippingInfo}
        handleInstructionChange={handleInstructionChange}
        instructions={instructions}
        setInstructions={setInstructions}
      />,
    );
  }, [
    handleInstructionChange,
    handleSaleOrder,
    instructions,
    isManagerAssigned,
    itemDetails,
    orderManagers,
    shippingType,
  ]);

  const handleSkipShippingCharges = useCallback(
    (dw) => {
      if (shippingType === "Combined") {
        setShippingInfo((prev) =>
          prev.map((item) => ({
            ...item,
            isDispatchWarehouse: item.warehouseId === dw.value,
          })),
        );
      } else {
        setShippingInfo((prev) =>
          prev.map((item) => ({
            ...item,
            isDispatchWarehouse: true,
          })),
        );
      }
      setGeneralInfo((prevState) => ({
        ...prevState,
        courierName: "Pick Up",
        toPay: false,
        deliveryPartners: prevState.deliveryPartners
          ? [...prevState.deliveryPartners, { label: "Self", value: "Self" }]
          : [{ label: "Self", value: "Self" }],
      }));
      setSkipped(true);
    },
    [shippingType],
  );

  if (skipped) {
    setTimeout(() => {
      handleSubmit();
    }, 700);
    setSkipped(false);
  }

  const openShippingChargesInfoModal = useCallback(
    (s, dw, tempShippingInfo, uw) => {
      setUniqueWarehouses(uw);
      handleOpenModal(
        <ShippingChargesInfoModal
          mode={mode}
          handleCloseModal={handleCloseModal}
          shippingType={s}
          itemDetails={itemDetails}
          shippingInfo={tempShippingInfo}
          setShippingInfo={setShippingInfo}
          dw={dw}
          ref={checkboxRef}
        />,
      );
    },
    [itemDetails, mode],
  );

  const openSelectDMModal = useCallback(
    (s, dw, tempShippingInfo, uw) => {
      handleOpenModal(
        <SelectDM
          mode={mode}
          handleCloseModal={handleCloseModal}
          uniqueWarehouses={uw}
          dispatchManagers={dispatchManagersRef.current}
          setShippingInfo={setShippingInfo}
          openShippingChargesInfoModal={() =>
            openShippingChargesInfoModal(s, dw, tempShippingInfo, uw)
          }
        />,
      );
    },
    [mode, openShippingChargesInfoModal],
  );

  const selectDispatchWarehouse = useCallback(
    (value) => {
      setDispatchWarehouse(value);
      setReceiptData((prev) => ({
        ...prev,
        warehousename: value.label,
        warehouseId: value.value,
      }));
      setShippingInfo((prev) => {
        const updatedShippingInfo = prev.map((item) => ({
          ...item,
          isDispatchWarehouse:
            item.warehouseId === value?.value ||
            item.warehousename === value.label,
        }));
        return updatedShippingInfo;
      });

      setTimeout(() => {
        setShippingInfo((prev) => {
          fetchDMs(
            prev.map(({ warehouseId, isDispatchWarehouse }) => ({
              warehouseId,
              isDispatchWarehouse,
            })),
            "",
          );
          return prev;
        });
      }, 0);
    },
    [fetchDMs],
  );

  const openShippingModal2 = useCallback(
    (shippingType, type2) => {
      handleOpenModal(
        <ShippingChargesModal2
          mode={mode}
          orderId={orderId}
          close={() => handleCloseModal()}
          skipShippingCharges={(dw) => handleSkipShippingCharges(dw)}
          itemsdetails={getValidSaleItems(itemDetails)}
          isShippingBlocked={isShippingBlocked}
          shippingType={shippingType}
          pincode={shippingAddress.pincode}
          shippingInfo={shippingInfo}
          setShippingInfo={setShippingInfo}
          openSelectDMModal={openSelectDMModal}
          setGeneralInfo={setGeneralInfo}
          type2={type2}
          fetchDMs={(a, b) => fetchDMs(a, b)}
          setDispatchWarehouse={setDispatchWarehouse}
          selectDispatchWarehouse={selectDispatchWarehouse}
        />,
      );
    },
    [
      mode,
      orderId,
      itemDetails,
      isShippingBlocked,
      shippingAddress.pincode,
      shippingInfo,
      openSelectDMModal,
      selectDispatchWarehouse,
      handleSkipShippingCharges,
      fetchDMs,
    ],
  );

  useEffect(() => {
    if (isModalOpen && modalContent?.type === ConfirmOrder) {
      handleSubmit();
    }
  }, [handleSubmit, isModalOpen, modalContent?.type]);

  useEffect(() => {
    if (flag === "edit" || flag === "view") {
      generatePaymentLink(orderId);
    }
  }, [flag, generatePaymentLink, orderId]);

  const handleCancelOrder = async () => {
    const apiData = {
      managerId: managerId,
      orderId: orderId,
    };
    try {
      const result = await fetchData("order/cancelOrder", apiData);
      if (result.status === "success") {
        show("Order cancelled successfully", "success");
        navigate("/orders");
      }
    } catch (error) {
      show(error, "error");
    }
  };

  const handleRequestForCancel = async (reason, warehouseId) => {
    const apiData = {
      managerId: managerId,
      orderId: orderId,
      reqType: "Request For Cancel",
      reqIssue: reason,
      warehouseId: warehouseId,
    };
    try {
      const result = await fetchData("order/orderhelp", apiData);
      if (result.status === "success") {
        show(result.msg, "success");
        navigate("/orders");
      } else {
        show(result.msg, "warning");
      }
    } catch (error) {
      show(error, "error");
    }
  };

  const openCancelOrderModal = () => {
    handleOpenModal(
      <ManagerModal
        heading={"Cancel Order"}
        centerHeading={"Are you sure want to cancel this Order?"}
        subHeading={"To confirm! type cancel in the text field."}
        targetWord={"cancel"}
        handleCloseModal={() => handleCloseModal()}
        handleSubmit={() => handleCancelOrder()}
        focus={true}
      />,
    );
  };

  const openRequestForCancelModal = () => {
    handleOpenModal(
      <RequestForCancelModal
        mode={mode}
        handleCloseModal={() => handleCloseModal()}
        handleSubmit={(reason, warehouseId) =>
          handleRequestForCancel(reason, warehouseId)
        }
        type="order"
        uniqueWarehouses={uniqueWarehouses}
      />,
    );
  };

  const openShippingTypeModal = () => {
    handleOpenModal(
      <ShippingTypeModal
        mode={mode}
        handleCloseModal={() => handleCloseModal()}
        setShippingType={setShippingType}
        openShippingModal2={(shippingType) => openShippingModal2(shippingType)}
      />,
    );
  };

  const dispatchDetailsClick = () => {
    if (shippingInfo.length === 1) {
      navigate(
        "/dispatch/details/" + orderId + "/" + shippingInfo[0].warehouseId,
      );
    } else {
      handleOpenModal(
        <SelectWarehouse
          mode={mode}
          handleCloseModal={() => handleCloseModal()}
          orderId={orderId}
          shippingInfo={shippingInfo}
        />,
      );
    }
  };

  useEffect(() => {
    itemInpRefs.current = Array(itemDetails.length)
      .fill()
      .map((_, i) => itemInpRefs.current[i] || null);
  }, [itemDetails.length]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Tab") {
        event.preventDefault();
      }

      if (loadingBtn) {
        event.preventDefault();
        event.stopPropagation();
      }

      if (flag === "edit" && !isModalOpen) {
        const isInputFocused = ["INPUT", "TEXTAREA", "SELECT"].includes(
          document.activeElement.tagName,
        );
        if (
          !isInputFocused &&
          generalInfo.orderType !== "online" &&
          event.key.toLowerCase() === "e"
        ) {
          event.preventDefault();
          editBtnClick();
        }
      }
    };

    window.addEventListener("keydown", handleKeyDown, true);

    return () => {
      window.removeEventListener("keydown", handleKeyDown, true);
    };
  }, [editBtnClick, flag, isModalOpen, loadingBtn, generalInfo.orderType]);

  useEffect(() => {
    if (!itemDetails || itemDetails.length === 0) return;

    const amount = itemDetails.reduce((sum, item) => {
      if (item.amount && !isNaN(item.amount)) {
        return sum + parseFloat(item.amount);
      }
      return sum;
    }, 0);

    const cartPriceSum = itemDetails.reduce((sum, currentItem) => {
      return (
        sum +
        parseFloat(currentItem.price ?? 0) * parseFloat(currentItem.qty ?? 0)
      );
    }, 0);

    const cartTotal = itemDetails
      .map((x) =>
        !x.accessories
          ? 0
          : x.accessories
              .map((y) => (y.accessoriesQty ?? 0) * (y.accessoriesPrice ?? 0))
              .reduce((a, b) => a + b, 0),
      )
      .reduce((a, b) => a + b, 0);

    const subtotal = (cartPriceSum ?? 0) + (cartTotal ?? 0);

    const gettotalAmount =
      subtotal +
      parseFloat(
        generalInfo.toPay
          ? 0
          : generalInfo.deliveryPartner === "Self"
            ? 0
            : (generalInfo.shippingCharge ?? 0),
      );

    const totalAmount = Math.round(gettotalAmount);

    setGeneralInfo((prev) => ({
      ...prev,
      amount,
      cartPriceSum,
      cartTotal,
      subtotal,
      totalAmount,
    }));
  }, [
    itemDetails,
    generalInfo.toPay,
    generalInfo.deliveryPartner,
    generalInfo.shippingCharge,
  ]);

  useEffect(() => {
    const { totalAmount } = receipts.reduce(
      (acc, receipt) => {
        if (receipt.status === "Received") {
          acc.totalAmount += receipt.paymentAmount;
        }
        if (receipt.status === "Cancelled") {
          acc.cancelledAmount += receipt.paymentAmount;
        }
        return acc;
      },
      { totalAmount: 0, cancelledAmount: 0 },
    );

    setReceiptTotalAmount(totalAmount);
  }, [receipts]);

  const allReceived = receipts.every(
    (receipt) => receipt.status === "Received",
  );

  const hasPod = receipts.some((receipt) => receipt.status === "POD Pending");

  const shouldShowRequestForCancel =
    orderId &&
    ["Packing In Progress", "Packed", "Dispatched"].includes(
      generalInfo.status,
    ) &&
    generalInfo.status !== "Cancelled" &&
    generalInfo.reqType !== "Request For Cancel";

  const shouldShowCancelOrder =
    orderId &&
    ["Payment Pending", "Payment Under Verification"].includes(
      generalInfo.status,
    ) &&
    generalInfo.status !== "Cancelled" &&
    generalInfo.reqType !== "Request For Cancel";

  const hasDispatchedOrCompleted = shippingInfo.some(
    (item) =>
      item.dispatchStatus === "Completed" ||
      item.dispatchStatus === "Dispatched",
  );

  useEffect(() => {
    onOrderData({
      loading,
      orderId,
      type: generalInfo.orderType,
      status: generalInfo.status,
      orderManagerName: generalInfo.orderManagerName,
      createdBy: generalInfo.createdBy,
      orderDate: generalInfo.orderDate,
    });
  }, [
    generalInfo.createdBy,
    generalInfo.orderDate,
    generalInfo.orderManagerName,
    generalInfo.orderType,
    generalInfo.status,
    loading,
    onOrderData,
    orderId,
  ]);

  const verifyEntries = () => {
    const warnings = [];
    if (
      itemDetails.every(
        (item) =>
          item.amount === "" &&
          item.price === "" &&
          item.unit === "" &&
          item.qty === "" &&
          item.itemNo === "",
      ) ||
      itemDetails.some((item) =>
        Object.values(item).every((value) => value === ""),
      )
    ) {
      warnings.push("Item Details are required");
    }
    if (warnings?.length === 0) {
      return true;
    } else {
      show(warnings.join(" "), "warning");
      return false;
    }
  };

  const totalShippingCharges = shippingInfo?.reduce(
    (sum, item) => sum + (Number(item?.shippingCharge) || 0),
    0,
  );

  useEffect(() => {
    setGeneralInfo((prev) => ({
      ...prev,
      shippingCharge: totalShippingCharges,
    }));
  }, [totalShippingCharges]);

  const headerData = [
    "S.No",
    "Item No",
    "Product",
    "Collection",
    "Warehouse",
    "Quantity",
    "Unit",
    "Rate",
    "Amount",
  ];

  const printSummarySlip = useReactToPrint({
    content: () => summarySlipRef.current,
  });

  const handlePrintSummary = async () => {
    await fetchOrder();
    setTimeout(() => {
      printSummarySlip();
    }, 300);
  };

  const openAdvancePaymentInfoModal = (data) => {
    handleOpenModal(<AdvanceAmountModalInfo mode={mode} data={data} totalAmount={generalInfo?.totalAmount}/>);
  };

  return (
    <>
      <ModalWrapper isOpen={isModalOpen} onClose={handleCloseModal} noBtn>
        {modalContent}
      </ModalWrapper>

      <div className={styles.so_scroll_wrapper} ref={scroll_wrapper_ref}>
        <form className={styles.so_form}>
          <div className={styles.so_form_1}>
            {loading && (flag === "edit" || flag === "view") ? (
              <div>
                <Skeleton
                  lines={1}
                  thickness={4.5}
                  additionalStyles={{
                    marginBottom: "0px",
                    marginTop: "20px",
                  }}
                />
              </div>
            ) : (
              <div style={{ position: "relative" }}>
                <InputTag
                  ref={dealerInpRef}
                  labelText={"Company or Dealer's Name / ID"}
                  placeholderText={"Search Dealer"}
                  padding={"8px"}
                  fontSize={"12px"}
                  value={
                    useFallback && !searchDealer
                      ? generalInfo.storeName && generalInfo.dealerName
                        ? `${generalInfo.storeName} / ${generalInfo.dealerName}`
                        : generalInfo.storeName || generalInfo.dealerName || ""
                      : searchDealer
                  }
                  onChange={(e) => {
                    setSearchDealer(e.target.value);
                    setUseFallback(false);
                  }}
                  onFocus={() => {
                    if (flag === "create") {
                      setShowDealerSearch(true);
                    }
                  }}
                  onBlur={() => {
                    setShowDealerSearch(false);
                    if (searchDealer === "") {
                      setUseFallback(true);
                    }
                  }}
                  onKeyDown={(e) => handleDealerKeyDown(e)}
                  maxLength={100}
                  required
                  enterKeyHint={"enter"}
                  readOnly={flag === "view"}
                />

                {showDealerSearch && (
                  <SearchDealer
                    mode={mode}
                    results={dealerResults}
                    loading={dealerLoading}
                    currentIndex={currentIndex}
                    onDealerSelect={handleSelectDealer}
                    openAddDealerModal={openAddDealerModal}
                  />
                )}
              </div>
            )}

            {loading && (flag === "edit" || flag === "view") ? (
              <div>
                <Skeleton
                  lines={1}
                  thickness={4.5}
                  additionalStyles={{
                    marginBottom: "0px",
                    marginTop: "20px",
                  }}
                />
              </div>
            ) : (
              <div>
                <InputTag
                  labelText={"Shipping Address"}
                  placeholderText={"Enter Dealer Address"}
                  value={
                    [
                      shippingAddress.street,
                      shippingAddress.city,
                      shippingAddress.district,
                      shippingAddress.state,
                      shippingAddress.pincode,
                    ]
                      .filter(Boolean)
                      .join(" ") || ""
                  }
                  padding={"8px"}
                  fontSize={"12px"}
                  required
                />
              </div>
            )}
          </div>

          <div className={styles.so_form_1}>
            <div>
              {loading && (flag === "edit" || flag === "view") ? (
                <div style={{ width: "100%" }}>
                  <Skeleton
                    lines={1}
                    thickness={4.5}
                    additionalStyles={{
                      marginBottom: "0px",
                      marginTop: "20px",
                    }}
                  />
                </div>
              ) : (
                <div className={styles.warehouse_selectors}>
                  <div
                    style={{
                      width: "100%",
                      position: "relative",
                    }}
                  >
                    {flag !== "create" && (
                      <div className={styles.voucher_det}>
                        <p style={{ color: mode && "#FFFFFF" }}>
                          {shippingType}
                        </p>
                      </div>
                    )}
                    <Selection
                      dropDownText={"Select"}
                      label={"Warehouses"}
                      value={
                        shippingInfo &&
                        shippingInfo?.map((s) => ({
                          label: s.warehousename,
                          value: s.warehouseId,
                        }))
                      }
                      options={
                        warehouses?.map((w) => ({
                          label: w.warehousename,
                          value: w.warehouseId,
                        })) || []
                      }
                      onchange={(option) => {
                        const selectedValue = option.value;
                        setGeneralInfo((prevState) => ({
                          ...prevState,
                          warehouses: selectedValue,
                        }));
                      }}
                      disableOpen={true}
                    />
                  </div>
                </div>
              )}
            </div>

            {loading && (flag === "edit" || flag === "view") ? (
              <div>
                <Skeleton
                  lines={1}
                  thickness={4.5}
                  additionalStyles={{
                    marginBottom: "0px",
                    marginTop: "20px",
                  }}
                />
              </div>
            ) : (
              <div>
                <div style={{ width: "100%", position: "relative" }}>
                  <div className={styles.voucher_det}>
                    <p style={{ color: mode && "#FFFFFF" }}>
                      {[...new Set(shippingInfo?.map((s) => s?.courierName))]
                        .filter((name) => name)
                        .join(", ")}
                    </p>
                  </div>
                  <Selection
                    label="Delivery Method"
                    dropDownText="Select"
                    value={generalInfo.deliveryPartners || []}
                    options={[
                      { label: "Self", value: "Self" },
                      ...methodPartners?.map((m) => ({
                        label: m.methodName || m.partnerName,
                        value: m.methodName || m.partnerName,
                      })),
                    ]}
                    onchange={(option) => {
                      const selectedValue = option.value;
                      setGeneralInfo((prevState) => ({
                        ...prevState,
                        deliveryPartners: selectedValue,
                      }));

                      if (selectedValue === "Self") {
                        handleSkipShippingCharges();
                      } else {
                        if (isNoCase) {
                          setGeneralInfo((prev) => ({
                            ...prev,
                            shippingCharge: 0,
                          }));
                        }
                      }
                      shippingRef.current?.focus();
                    }}
                    disableOpen={true}
                    collapseDuplicates={true}
                  />

                  {isEditMode && (
                    <div className={styles.change_ship}>
                      <span
                        style={{ color: !mode && "#4164E3" }}
                        onClick={() => openShippingModal2(shippingType, "")}
                      >
                        Update
                      </span>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </form>

        <ul className={styles.p_table}>
          <div
            className={styles.p_table_header_con}
            style={{
              visibility: loading && "hidden",
            }}
          >
            <li
              className={`${styles.p_table_header} ${
                mode ? styles.p_table_header_dark : ""
              }`}
            >
              {headerData?.map((h, index) => (
                <div className={styles.entry_2} key={`${h}-${index}`}>
                  {h}
                </div>
              ))}
            </li>
            {(flag === "create" || isEditMode) && itemDetails?.length > 1 && (
              <div
                style={{
                  visibility: "hidden",
                  display: flag === "view" && "none",
                }}
              >
                <RemoveIcon />
              </div>
            )}
          </div>

          <div className={styles.p_table_list}>
            <>
              {itemDetails?.map((item, index) => (
                // ── Use _uid as key so removing an item never shifts
                //    React component instances or their local state ──────
                <React.Fragment key={item._uid}>
                  {flag === "create" || (flag === "edit" && isEditMode) ? (
                    <NewItemList
                      mode={mode}
                      index={index}
                      item={item}
                      itemInpRefs={(el) => {
                        if (el) itemInpRefs.current[index] = el;
                      }}
                      quantityRefs={qtyInputRefs}
                      onItemChange={(field, value) =>
                        handleItemChange(index, field, value)
                      }
                      onRemove={() => removeItem(index)}
                      onAddNewItem={handleAddNewItem}
                      itemDetailsLength={itemDetails.length}
                      itemFocus={handleItemInputFocus}
                      itemBlur={handleItemInputBlur}
                      focusedItemIndex={focusedItemIndex}
                      showItemSearch={showItemSearch}
                      setShowItemSearch={setShowItemSearch}
                      onShowDesc={(value) => setShowDescriptionInput(value)}
                      onCompletion={() => {
                        if (shippingInfo.length === 1) {
                          openShippingModal2("Combined", "normal");
                        } else {
                          openShippingTypeModal();
                        }
                      }}
                      flag={flag}
                    />
                  ) : (
                    <>
                      {loading ? (
                        <div>
                          <Skeleton
                            lines={
                              itemDetails?.length === 1
                                ? 1
                                : itemDetails?.length / 2
                            }
                            thickness={5}
                            additionalStyles={{
                              marginBottom: "0px",
                              marginTop: "0px",
                            }}
                          />
                        </div>
                      ) : (
                        <ItemList d={item} index={index} mode={mode} />
                      )}
                    </>
                  )}
                </React.Fragment>
              ))}
            </>
          </div>

          {(flag === "create" || isEditMode) && (
            <div
              className={styles.cricle_btn}
              onClick={() => {
                handleAddNewItem();
              }}
            >
              <TestTopAddDealerIcon color="#4164E3" />
            </div>
          )}

          {showDescriptionInput && (flag === "create" || flag === "edit") && (
            <div className={styles.so_instc}>
              <p>Press Enter to Add Item</p>
              <DividerIcon />
              <p>Double Enter for Next Option</p>
              <DividerIcon />
              <p>Ctrl + Backspace for Remove Item</p>
            </div>
          )}
        </ul>
      </div>

      {loading ? (
        <div
          style={{ padding: "0", boxShadow: "none" }}
          className={`${styles.so_footer} ${mode ? styles.so_footer_dark : ""}`}
        >
          <Skeleton
            lines={1}
            thickness={5}
            additionalStyles={{
              marginBottom: "0px",
              marginTop: "0px",
              borderRadius: "15px 15px 0 0",
            }}
          />
        </div>
      ) : (
        <div
          className={`${styles.so_footer} ${mode ? styles.so_footer_dark : ""}`}
        >
          {(flag === "edit" || flag === "view") && (
            <div className={styles.so_footer_left}>
              <div
                className={`${styles.so_receipt_data} ${
                  mode ? styles.so_receipt_data_dark : ""
                }`}
              >
                <div
                  className={`${styles.so_receipt_data_header} ${
                    mode ? styles.so_receipt_data_header_dark : ""
                  }`}
                  style={{ cursor: "auto" }}
                >
                  <div className="col">Receipt ID</div>
                  <div className="col">Method</div>
                  <div className="col">Amount</div>
                  <div className="col">Status</div>
                </div>
                <div
                  className={styles.scroll_con}
                  style={{ display: receipts?.length === 0 && "none" }}
                >
                  {receipts?.length !== 0 &&
                    receipts?.map((r, index) => (
                      <div
                        className={`${styles.so_receipt_data_entry} ${
                          mode ? styles.so_receipt_data_entry_dark : ""
                        }`}
                        key={index}
                        onClick={() => {
                          handleOpenModal(
                            <AddReceiptModal
                              handleCloseModal={handleCloseModal}
                              mode={mode}
                              totalAmount={generalInfo.totalAmount}
                              accounts={accounts}
                              receiptData={r}
                              updateReceiptData={async (updatedData) =>
                                updateReceiptData(
                                  updatedData,
                                  orderId,
                                  r.receiptId,
                                )
                              }
                              type={"create"}
                              flag={"notupdateamount"}
                              uniqueWarehouses={uniqueWarehouses}
                              shippingType={shippingType}
                              dispatchWarehouse={dispatchWarehouse}
                              setReceiptData={setReceiptData}
                              isModalOpen={isModalOpen}
                              receiptTotalAmount={receiptTotalAmount}
                              isSelf={isSelf}
                            />,
                          );
                        }}
                      >
                        <div className="col" key={index + r.receiptId}>
                          {r.receiptId}
                        </div>
                        <div className="col" key={index + r.paymentMethod}>
                          {r.paymentMethod}
                        </div>
                        <div className="col" key={index + r.paymentAmount}>
                          {r.paymentAmount}
                        </div>
                        <div
                          className="col"
                          key={index + r.status}
                          style={{ color: getStatusColor(r.status) }}
                        >
                          {r.status}
                        </div>
                      </div>
                    ))}
                </div>
              </div>

              {(receiptTotalAmount < generalInfo.totalAmount ||
                hasPod ||
                !allReceived) && (
                <div
                  className={styles.add_receipt_btn}
                  onClick={async () => {
                    await fetchDMs();
                    orderSuccessKeyPress("addReceipt");
                  }}
                >
                  <TestTopAddDealerIcon />
                </div>
              )}

              {allOrdersData?.order?.paymentStatus && (
                <div>
                  <p
                    style={{
                      color:
                        allOrdersData?.order?.paymentStatus === "Received"
                          ? "#297038"
                          : "#f11717",
                    }}
                  >
                    {allOrdersData?.order?.paymentStatus}
                  </p>
                </div>
              )}
            </div>
          )}

          <div className={styles.so_footer_right}>
            <div className={styles.right_btns}>
              {(flag === "edit" || flag === "view") && (
                <MoreDropdown
                  mode={mode}
                  onSummaryClick={handlePrintSummary}
                  onSlipClick={() => {
                    show("Coming soon...");
                  }}
                />
              )}

              {shouldShowRequestForCancel && (
                <Button
                  buttonIcon={<CancelIcon2 />}
                  buttonText={"Request for Cancel"}
                  buttonBgColor={"#000000"}
                  buttonTextColor={"#ffffff"}
                  buttonBorder={"none"}
                  buttonClick={openRequestForCancelModal}
                />
              )}

              {shouldShowCancelOrder && (
                <Button
                  buttonIcon={<CancelIcon2 />}
                  buttonText={"Cancel Order"}
                  buttonBgColor={"#000000"}
                  buttonTextColor={"#ffffff"}
                  buttonBorder={"none"}
                  buttonClick={openCancelOrderModal}
                />
              )}

              {(flag === "edit" || flag === "view") && (
                <Button
                  buttonIcon={<NewEyeIcon />}
                  buttonText={"Invoice"}
                  buttonBgColor={"#000000"}
                  buttonTextColor={"#ffffff"}
                  buttonBorder={"none"}
                  buttonClick={() =>
                    navigate("/orders/saleinvoice?orderId=" + orderId)
                  }
                />
              )}

              {hasDispatchedOrCompleted && (
                <Button
                  buttonIcon={<NewEyeIcon />}
                  buttonText={"Dispatch Details"}
                  buttonBgColor={"#000000"}
                  buttonTextColor={"#ffffff"}
                  buttonBorder={"none"}
                  buttonClick={dispatchDetailsClick}
                />
              )}

              {(flag === "edit" || flag === "view") &&
                generalInfo.status !== "Cancelled" &&
                generalInfo.reqType !== "Request For Cancel" && (
                  <Button
                    buttonIcon={<ShareIcon />}
                    buttonText={"Share"}
                    buttonBgColor={"#4164E3"}
                    buttonTextColor={"#ffffff"}
                    buttonBorder={"none"}
                    buttonClick={() => orderSuccessKeyPress("shareLink")}
                  />
                )}
            </div>

            <div
              className={`${styles.so_amount_info} ${
                mode ? styles.so_amount_info_dark : ""
              }`}
            >
              <div>
                <p>Sub Total:</p>
                <p>₹ {generalInfo.subtotal}</p>
              </div>

              <div className={styles.so_shipping}>
                <p>Shipping Charges:</p>{" "}
                <div className={styles.info_btn_con}>
                  <span
                    className={styles.info_btn}
                    onClick={() =>
                      openShippingChargesInfoModal(
                        shippingType,
                        dispatchWarehouse,
                        shippingInfo,
                      )
                    }
                  >
                    <InfoRounded color={mode ? "#FFFFFF" : "#1C274C"} />
                  </span>
                </div>
                <input
                  type="number"
                  value={
                    (generalInfo.deliveryPartner === "Self"
                      ? 0
                      : generalInfo.shippingCharge
                    )
                      ?.toString()
                      .replace(/^0+/, "") || 0
                  }
                  onChange={(e) => {
                    let value = Number(e.target.value);
                    if (value > 0) {
                      setGeneralInfo((prevState) => ({
                        ...prevState,
                        shippingCharge: value,
                      }));
                    } else {
                      setGeneralInfo((prevState) => ({
                        ...prevState,
                        shippingCharge: -1 * value,
                      }));
                    }
                  }}
                  readOnly={!isNoCase || flag === "view"}
                  maxLength="10"
                  onInput={(e) =>
                    (e.target.value = e.target.value.slice(0, 10))
                  }
                  style={mode ? { color: "#fff" } : {}}
                  ref={shippingRef}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      checkboxRef.current?.focus();
                    }
                  }}
                />
                <div className={styles.so_check}>
                  <p>To Pay</p>
                  <input
                    type="checkbox"
                    checked={generalInfo.toPay}
                    onChange={(e) => {
                      const isChecked = e.target.checked;

                      if (
                        isChecked &&
                        isNoCase &&
                        generalInfo.shippingCharge === 0
                      ) {
                        e.preventDefault();
                        show(
                          "Update shipping charges to check To Pay!",
                          "warning",
                        );
                        return;
                      }

                      setGeneralInfo((prevState) => ({
                        ...prevState,
                        toPay: isChecked,
                      }));
                    }}
                    ref={checkboxRef}
                    disabled={
                      flag === "view" || (flag === "edit" && !isEditMode)
                    }
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        handleSubmit();
                      }
                    }}
                  />
                </div>
                <p>
                  {loadingBtn ? (
                    <Spinner
                      borderWidth={"1px"}
                      height={10}
                      width={10}
                      color={mode ? "#000000" : "#4164E3"}
                    />
                  ) : (
                    <>
                      ₹{" "}
                      {generalInfo.deliveryPartner === "Self"
                        ? 0
                        : generalInfo.shippingCharge}
                    </>
                  )}
                </p>
              </div>

              <div>
                <p>
                  Total Amount(INR):{" "}
                  {receipts?.length > 0 && (
                    <span
                      className={styles.info_btn}
                      onClick={() => openAdvancePaymentInfoModal(receipts)}
                    >
                      <InfoRounded color={mode ? "#FFFFFF" : "#1C274C"} />
                    </span>
                  )}
                </p>

                <p>
                  {loadingBtn ? (
                    <Spinner
                      borderWidth={"1px"}
                      height={10}
                      width={10}
                      color={mode ? "#000000" : "#4164E3"}
                    />
                  ) : (
                    <>₹ {Number(generalInfo.totalAmount) || 0}</>
                  )}
                </p>
              </div>
            </div>

            {flag === "edit" && (
              <div>
                {isEditMode ? (
                  <>
                    {showSave ? (
                      <Button
                        buttonIcon={<SaveIcon />}
                        buttonText={"Save"}
                        buttonBgColor={"#4164E3"}
                        buttonTextColor={"#FFFFFF"}
                        buttonBorder={"none"}
                        buttonClick={() => {
                          if (verifyEntries()) {
                            handleSubmit();
                          }
                        }}
                      />
                    ) : (
                      <div className={styles.flex}>
                        <Button
                          buttonIcon={<CancelIcon2 />}
                          buttonText={"Cancel"}
                          buttonBgColor={"#000000"}
                          buttonTextColor={"#ffffff"}
                          buttonBorder={"none"}
                          buttonClick={() => setIsEditMode(false)}
                          loading={loadingBtn}
                        />
                      </div>
                    )}
                  </>
                ) : (
                  <>
                    {generalInfo.orderType !== "online" && (
                      <Button
                        buttonIcon={<EditManagerIcon />}
                        buttonText={"Edit"}
                        buttonBgColor={"#4164E3"}
                        buttonTextColor={"#FFFFFF"}
                        buttonBorder={"none"}
                        buttonClick={editBtnClick}
                      />
                    )}
                  </>
                )}
              </div>
            )}

            {flag === "create" && (
              <div>
                {showSave && (
                  <Button
                    buttonIcon={<SaveIcon />}
                    buttonText={"Save"}
                    buttonBgColor={"#4164E3"}
                    buttonTextColor={"#FFFFFF"}
                    buttonBorder={"none"}
                    buttonClick={() => {
                      if (verifyEntries()) {
                        handleSubmit();
                      }
                    }}
                  />
                )}
              </div>
            )}
          </div>
        </div>
      )}

      {/* ------------ Summary Slip ------------------- */}
      <div style={{ display: "none" }}>
        <NewSummarySlip
          ref={summarySlipRef}
          summarySlipData={itemDetails}
          generalInfo={allOrdersData?.order}
        />
      </div>
    </>
  );
};

export default SaleOrder;
